/* eslint-disable no-multiple-empty-lines */
/* eslint-disable no-trailing-spaces */
/* eslint-disable no-useless-computed-key */
export default {
	['较大']: 'Maior',
	['预设']: 'Padrão',
	['较小']: 'Menor',
	['字级大小']: 'Tamanho da fonte',
	['页面正在加载中']: 'Carregando a página...',
	['这可能需要几分钟的时间，请耐心等待']: 'Isso pode levar alguns minutos, por favor, aguarde.',
	['您所访问的页面不存在']: 'A página que você acessou não existe',
	['开始对话']: 'Iniciar conversa',
	['充值未到帐快速通道']: 'Canal rápido para recarga não creditada',
	['人工客服']: 'Atendimento humano',
	['已接听']: 'Atendido',
	['结束对话']: 'Encerrar conversa',
	['联络人工客服']: 'Atendimento ao cliente',
	['重新选择智能客服']: 'Selecionar assistente...',
	['感谢您使用本次服务，烦请拨冗补充填写调查，您宝贵的意见是我们前进的动力！']: 'Obrigado por utilizar nossos serviços. Por favor, reserve um momento para preencher a pesquisa. Sua opinião é nossa motivação!',
	['您觉得此次的服务品质如何？']: 'Como você avalia a qualidade deste atendimento?',
	['颗星']: 'Estrelas',
	['颗星(單數)']: 'Estrela',
	['不评分']: 'Não avaliar',
	['点选下方即可结束对话']: 'Clique abaixo para encerrar a conversa.',
	['请输入您的ID']: 'Por favor, insira seu ID',
	['ID不能为空']: 'O ID não pode estar vazio',
	['说明文字']: 'Descrição',
	['送出']: 'Enviar',
	['系统维护中']: 'Sistema em manutenção',
	['储存']: 'Salvar',
	['确认']: 'Confirmar',
	['取消']: 'Cancelar',
	['完成']: 'Concluir',
	['协作']: 'Colaboração',
	['转接']: 'Transferir',
	['离开']: 'Sair',
	['请选择服务对象开始通话']: 'Selecione o departamento para iniciar a conversa',
	['请填写表单']: 'Por favor, preencha o formulário',
	['本对话已经结束']: 'Esta conversa já foi encerrada',
	['客服已逾 {{second}} 秒未回应']: 'O atendente não responde há {{second}} segundos',
	['历史对话']: 'Conversas anteriores',
	['查无资料']: 'Nenhum dado encontrado',
	['标签']: 'Etiqueta',
	['正在输入中...']: 'Digitando...',
	['于']: 'em',
	['档案容量限制']: 'Limite de tamanho do arquivo',
	['不能为空']: 'Não pode estar em branco',
	['提交']: 'Enviar',
	['满意度']: 'Satisfação',
	['IP未知']: 'IP desconhecido',
	['地区未知']: 'Região desconhecida',
	['使用者环境未知']: 'Ambiente do usuário desconhecido',
	['关闭']: 'Fechar',
	['全萤幕截图成档案']: 'Capturar tela cheia para arquivo',
	['Mac用户']: 'Usuário Mac',
	['Windows用户']: 'Usuário Windows',
	['Windows键']: 'Tecla Windows',
	['全萤幕截图至剪贴簿']: 'Capturar tela cheia para área de transferência',
	['截图完成后请直接于文字输入处贴上']: 'Após capturar a tela, cole diretamente na área de texto',
	['使用Windows内建截图工具或者QQ软件截图功能，截图完成后请直接于文字输入处贴上']: 'Use a ferramenta de captura do Windows ou do QQ. Após capturar, cole diretamente na área de texto.',
	['截图']: 'Captura de tela',
	['档案']: 'Arquivo',
	['下载失败']: 'Falha no download',
	['请输入分类名称']: 'Insira o nome da categoria',
	['新增']: 'Adicionar',
	['更新']: 'Atualizar',
	['请选择一个分类']: 'Selecione uma categoria',
	['请输入标题']: 'Insira o título',
	['请输入内文']: 'Insira o conteúdo',
	['请上传图片']: 'Envie uma imagem',
	['快捷语']: 'Respostas rápidas',
	['图片']: 'Imagem',
	['管理分类']: 'Gerenciar categorias',
	['新增分类']: 'Adicionar categoria',
	['标题/内文']: 'Título/Conteúdo',
	['分类']: 'Categoria',
	['编辑']: 'Editar',
	['删除']: 'Excluir',
	['平台名称']: 'Nome da plataforma',
	['显示']: 'Exibir',
	['编辑服务平台']: 'Editar plataforma de atendimento',
	['若有服务中的客户，无法关闭服务平台']: 'Não é possível fechar a plataforma com clientes em atendimento',
	['确定']: 'OK',
	['人员列表']: 'Lista de atendentes',
	['服务人数']: 'Número de atendimentos',
	['选择转接人员']: 'Selecionar pessoa para transferência',
	['按此上传图片']: 'Clique aqui para enviar imagem',
	['确定要取消{{displayName}}协作邀请吗？']: 'Cancelar o convite de colaboração de {{-displayName}}?',
	['确定要结束{{displayName}}的协作吗？']: 'Encerrar a colaboração de {{-displayName}}?',
	['等待协作中']: 'Aguardando colaboração',
	['协作中']: 'Em colaboração',
	['负责人']: 'Responsável',
	['已选择']: 'Selecionado',
	['可协作人数已满']: 'Número máximo de colaboradores atingido',
	['选择协作人员']: 'Selecionar colaboradores',
	['提示']: 'Aviso',
	['请输入讯息']: 'Digite sua mensagem',
	['确定已經完成？']: 'Confirma que está concluído?',
	['常用图片']: 'Imagens frequentes',
	['用户']: 'Usuário',
	['个人']: 'Pessoal',
	['公共']: 'Público',
	['开始谈话']: 'Iniciar conversa',
	['等待中']: 'Aguardando',
	['客户已离开对话']: 'O cliente saiu da conversa',
	['正在转接给']: 'Transferindo para',
	['邀请你加入协作']: 'Convite para colaborar',
	['请求转接']: 'Solicitação de transferência',
	['正在服务中']: 'Em atendimento',
	['编辑平台']: 'Editar plataforma',
	['您的连线已中断']: 'Sua conexão foi interrompida',
	['正尝试重新连线']: 'Tentando reconectar',
	['重新登入']: 'Entrar novamente',
	['请先登入']: 'Faça login primeiro',
	['帐号']: 'Conta',
	['帐号不能为空']: 'A conta não pode estar vazia',
	['请输入帐号']: 'Insira a conta',
	['密码']: 'Senha',
	['密码不能为空']: 'A senha não pode estar vazia',
	['请输入密码']: 'Insira a senha',
	['登录']: 'Entrar',
	['客服系统客服端']: 'Console do atendente',
	['平台异动，请重新整理']: 'Plataforma alterada, atualize a página',
	['客服系统升级维护中，请您晚点再联系线上客服，谢谢']: 'O sistema está em manutenção, tente novamente mais tarde. Obrigado',
	['客服系统进入升级维护作业，很抱歉中断您的对话，请您晚点再联系线上客服']: 'O sistema está em manutenção. Desculpe a interrupção, contate novamente o atendimento mais tarde',
	['请稍后再试']: 'Por favor, tente novamente mais tarde',
	['是']: 'Sim',
	['否']: 'Não',
	['等于']: 'Igual a',
	['包含']: 'Contém',
	['排除']: 'Excluir',
	['大于']: 'Maior que',
	['少于']: 'Menor que',
	['数量区间']: 'Intervalo de quantidade',
	['客服对话数']: 'Conversas do atendente',
	['客戶对话数']: 'Conversas do cliente',
	['即时资讯']: 'Informações em tempo real',
	['报表分析']: 'Análise de relatórios',
	['平均通话时间']: 'Tempo médio de chamada',
	['回覆通话数']: 'Chamadas respondidas',
	['平均等待时间']: 'Tempo médio de espera',
	['客户满意度']: 'Satisfação do cliente',
	['历史对话记录']: 'Histórico de conversas',
	['操作日志']: 'Registro de operações',
	['智能客服设定']: 'Configurações do atendimento inteligente',
	['机器人设定']: 'Configurações do bot',
	['版本管理']: 'Gestão de versões',
	['档案总览']: 'Visão geral de arquivos',
	['设定']: 'Configurações',
	['公司管理']: 'Gestão de empresas',
	['维修管理']: 'Gestão de manutenção',
	['一般设定']: 'Configurações gerais',
	['公告管理']: 'Gestão de anúncios',
	['帐号管理']: 'Gestão de contas',
	['平台管理']: 'Gestão de plataformas',
	['角色管理']: 'Gestão de perfis',
	['团队管理']: 'Gestão de equipes',
	['标签管理']: 'Gestão de etiquetas',
	['查询']: 'Pesquisar',
	['重置']: 'Redefinir',
	['今天']: 'Hoje',
	['昨天']: 'Ontem',
	['过去7天']: 'Últimos 7 dias',
	['过去10天']: 'Últimos 10 dias',
	['过去一个月']: 'Último mês',
	['过去90天']: 'Últimos 90 dias',
	['LOGO 预览']: 'Visualizar LOGO',
	['档案格式：PNG、JPG，长宽不超过']: 'Formato: PNG, JPG, dimensões não superiores a',
	['档案太大或格式不支援']: 'Arquivo muito grande ou formato não suportado',
	['且档案大小不得大于']: 'e o tamanho do arquivo não pode exceder',
	['上传档案']: 'Enviar arquivo',
	['新增IP白名单成功']: 'IP adicionado à lista branca com sucesso',
	['删除IP白名单成功']: 'IP removido da lista branca com sucesso',
	['请输入欲查询的IP']: 'Insira o IP a consultar',
	['请输入IP']: 'Insira o IP',
	['备注']: 'Observação',
	['备注不能为空']: 'A observação não pode estar vazia',
	['请输入备注']: 'Insira a observação',
	['新增时间']: 'Data de criação',
	['操作']: 'Ações',
	['IP白名单']: 'Lista branca de IP',
	['新增IP']: 'Adicionar IP',
	['新增IP白名单']: 'Adicionar à lista branca de IP',
	['确定删除此IP?']: 'Confirma excluir este IP?',
	['平台']: 'Plataforma',
	['团队']: 'Equipe',
	['全体']: 'Todos',
	['客服']: 'Atendente',
	['客服系统']: 'Sistema de atendimento',
	['个人帐号设定']: 'Configurações da conta pessoal',
	['最少6码']: 'Mínimo 6 caracteres',
	['最多20码']: 'Máximo 20 caracteres',
	['不能有空白']: 'Não pode conter espaços',
	['应至少包含1个英文和数字']: 'Deve conter ao menos 1 letra e 1 número',
	['公司名称']: 'Nome da empresa',
	['僅能输入英文和数字']: 'Apenas letras e números',
	['应至少包含1个英文']: 'Deve conter ao menos 1 letra',
	['最少5码']: 'Mínimo 5 caracteres',
	['IP不能为空']: 'O IP não pode estar vazio',
	['非IP位址']: 'Não é um endereço IP válido',
	['最多500个字']: 'Máximo 500 caracteres',
	['启用']: 'Ativar',
	['禁用']: 'Desativar',
	['对话量']: 'Volume de conversas',
	['目前客户数']: 'Clientes atuais',
	['目前客服数']: 'Atendentes atuais',
	['接通对话量']: 'Conversas atendidas',
	['全部']: 'Todos',
	['最近一天']: 'Último dia',
	['最近一周']: 'Última semana',
	['最近一月']: 'Último mês',
	['新增过滤器']: 'Adicionar filtro',
	['请输入模組名称']: 'Insira o nome do módulo',
	['储存过滤模組']: 'Salvar módulo de filtro',
	['读取过滤模組']: 'Carregar módulo de filtro',
	['确定要删除模組']: 'Confirma excluir o módulo?',
	['分钟']: 'minutos',
	['接通时间']: 'Hora da conexão',
	['通话时间']: 'Tempo de chamada',
	['请选择或输入时间']: 'Selecione ou insira o tempo',
	['等待时间']: 'Tempo de espera',
	['对话搜寻']: 'Pesquisar conversa',
	['请输入对话']: 'Insira a conversa',
	['客戶 ID']: 'ID do cliente',
	['请输入客戶ID']: 'Insira o ID do cliente',
	['对话浏览模式']: 'Modo de visualização de conversa',
	['筆']: 'registros',
	['客服本名']: 'Nome real do atendente',
	['进入时间']: 'Hora de entrada',
	['客服昵称']: 'Apelido do atendente',
	['客服系统管理端']: 'Console de administração',
	['数量']: 'Quantidade',
	['尚未上传档案']: 'Nenhum arquivo enviado',
	['输入文字']: 'Inserir texto',
	['请在此输入文字']: 'Insira o texto aqui',
	['添加项目']: 'Adicionar item',
	['请选择']: 'Selecione',
	['新增文字']: 'Adicionar texto',
	['新增档案']: 'Adicionar arquivo',
	['選項']: 'Opções',
	['勾选标题']: 'Título de seleção',
	['文字內容不能为空']: 'O conteúdo de texto não pode estar vazio',
	['添加']: 'Adicionar',
	['上传标题']: 'Título de envio',
	['单选标题']: 'Título de escolha única',
	['输入框标题']: 'Título do campo de entrada',
	['请输入']: 'Por favor, insira',
	['输入框']: 'Campo de entrada',
	['单选']: 'Escolha única',
	['核取方块']: 'Caixa de seleção',
	['请选择一个标签']: 'Selecione uma etiqueta',
	['确定要删除此项目和其所有子项目？']: 'Confirma excluir este item e todos os subitens?',
	['答案']: 'Resposta',
	['表单']: 'Formulário',
	['清除此阶层设定']: 'Limpar configuração deste nível',
	['请输入此阶层问题']: 'Insira a pergunta deste nível',
	['新增选项']: 'Adicionar opção',
	['新增表单']: 'Adicionar formulário',
	['新增答案']: 'Adicionar resposta',
	['新增充值表单']: 'Adicionar formulário de recarga',
	['若切换种类后, 将清除原有的和其子项目资料']: 'Ao alterar o tipo, os dados originais e seus subitens serão apagados',
	['确定要清除所有资料和其子项目资料？']: 'Confirma apagar todos os dados e seus subitens?',
	['阶层']: 'Nível',
	['开场语']: 'Mensagem de boas-vindas',
	['开场语不能为空']: 'A mensagem de boas-vindas não pode estar vazia',
	['结尾感谢语']: 'Mensagem de agradecimento final',
	['结尾感谢语不能为空']: 'A mensagem de agradecimento não pode estar vazia',
	['发布']: 'Publicar',
	['复制']: 'Copiar',
	['选择目的平台']: 'Selecionar plataforma de destino',
	['确定复制到']: 'Confirma copiar para',
	['是否要正式发布到使用环境？']: 'Publicar oficialmente no ambiente de produção?',
	['储存版本']: 'Salvar versão',
	['版本名称']: 'Nome da versão',
	['请输入版本名称']: 'Insira o nome da versão',
	['确定是否储存此版本']: 'Confirma salvar esta versão?',
	['版本储存成功']: 'Versão salva com sucesso',
	['最多10个字']: 'Máximo 10 caracteres',
	['公告一']: 'Anúncio 1',
	['公告二']: 'Anúncio 2',
	['公告三']: 'Anúncio 3',
	['公告储存成功']: 'Anúncio salvo com sucesso',
	['标题']: 'Título',
	['內文']: 'Conteúdo',
	['修改登入密码']: 'Alterar senha',
	['修改基本资讯']: 'Editar informações básicas',
	['昵称']: 'Apelido',
	['昵称不能为空']: 'O apelido não pode estar vazio',
	['请输入昵称']: 'Insira o apelido',
	['本名']: 'Nome real',
	['本名不能为空']: 'O nome real não pode estar vazio',
	['请输入本名']: 'Insira o nome real',
	['选择图像']: 'Selecionar imagem',
	['状态']: 'Status',
	['平台代码']: 'Código da plataforma',
	['平台代码不能为空']: 'O código da plataforma não pode estar vazio',
	['使用ID模式登入']: 'Entrar usando modo ID',
	['新增平台']: 'Adicionar plataforma',
	['修改平台']: 'Editar plataforma',
	['确定重新产生Key/IV?']: 'Confirma regenerar Key/IV?',
	['进入公司成功']: 'Empresa acessada com sucesso',
	['确定禁用公司?']: 'Confirma desativar a empresa?',
	['确定启用公司?']: 'Confirma ativar a empresa?',
	['修改公司']: 'Editar empresa',
	['进入公司']: 'Acessar empresa',
	['确定进入公司?']: 'Confirma acessar a empresa?',
	['新增标签']: 'Adicionar etiqueta',
	['代号']: 'Código',
	['代号不可为空']: 'O código não pode estar vazio',
	['名称']: 'Nome',
	['名称不可为空']: 'O nome não pode estar vazio',
	['颜色']: 'Cor',
	['颜色不可为空']: 'A cor não pode estar vazia',
	['进入标签']: 'Etiqueta de entrada',
	['修改标签']: 'Editar etiqueta',
	['确定开启进入标签?']: 'Confirma ativar a etiqueta de entrada?',
	['确定关闭进入标签?']: 'Confirma desativar a etiqueta de entrada?',
	['确定删除此标签?']: 'Confirma excluir esta etiqueta?',
	['标签创建成功']: 'Etiqueta criada com sucesso',
	['标签更新成功']: 'Etiqueta atualizada com sucesso',
	['进入标签更新成功']: 'Etiqueta de entrada atualizada com sucesso',
	['标签删除成功']: 'Etiqueta excluída com sucesso',
	['请输入代号、名称等关键字']: 'Insira código, nome ou outras palavras-chave',
	['设定开场白成功']: 'Mensagem de boas-vindas configurada com sucesso',
	['客戶进入开场白']: 'Mensagem de boas-vindas ao cliente',
	['客戶进入开场白不可为空']: 'A mensagem de boas-vindas não pode estar vazia',
	['第一次通知时间']: 'Primeiro tempo de notificação',
	['第{{count}}次通知时间']: '{{count}}º tempo de notificação',
	['设置错误']: 'Erro de configuração',
	['设定等待过长通知时间成功']: 'Tempo de notificação por espera configurado com sucesso',
	['秒']: 'segundos',
	['对话自动断开时间']: 'Tempo de desconexão automática da conversa',
	['未发话时间']: 'Tempo sem falar',
	['未发话提示文字']: 'Texto de aviso por inatividade',
	['设定对话断开成功']: 'Desconexão da conversa configurada com sucesso',
	['Favicon预览']: 'Visualizar Favicon',
	['更换 Favicon 成功']: 'Favicon alterado com sucesso',
	['档案格式：ICO，長寬不超過 32x32 px']: 'Formato: ICO, dimensões não superiores a 32x32 px',
	['更换 LOGO 成功']: 'LOGO alterado com sucesso',
	['智能客服']: 'Assistente Virtual',
	['设定通道成功']: 'Canal configurado com sucesso',
	['设定提示音效成功']: 'Som de notificação configurado com sucesso',
	['单音']: 'Som único',
	['循环音']: 'Som em loop',
	['编号']: 'Número',
	['资料类型']: 'Tipo de dado',
	['资料类型不可为空']: 'O tipo de dado não pode estar vazio',
	['数字']: 'Número',
	['字串']: 'String',
	['布林']: 'Booleano',
	['建立标签成功']: 'Etiqueta criada com sucesso',
	['修改标签成功']: 'Etiqueta editada com sucesso',
	['删除标签成功']: 'Etiqueta excluída com sucesso',
	['更换 LOGO']: 'Alterar LOGO',
	['更换 Favicon']: 'Alterar Favicon',
	['对话断开']: 'Desconexão da conversa',
	['等待过长通知时间']: 'Tempo de notificação por espera prolongada',
	['开场白']: 'Mensagem de boas-vindas',
	['提示音效设定']: 'Configurações de som de notificação',
	['通道设定']: 'Configurações de canal',
	['自定义标签']: 'Etiquetas personalizadas',
	['开启维修模式将会停止客服系统运作。确定要开启嗎？']: 'Ativar o modo de manutenção interromperá o sistema. Confirma ativar?',
	['关闭维修模式，客服系统将会继续运作。确定要关闭嗎？']: 'Desativar o modo de manutenção reiniciará o sistema. Confirma desativar?',
	['状态更新成功']: 'Status atualizado com sucesso',
	['通知讯息更新成功']: 'Mensagem de notificação atualizada com sucesso',
	['维修模式']: 'Modo de manutenção',
	['通知讯息设定']: 'Configurações de mensagem de notificação',
	['尚未连线状态']: 'Status offline',
	['尚未连线状态描述']: 'Descrição do status offline',
	['已连线状态']: 'Status online',
	['已连线状态描述']: 'Descrição do status online',
	['开启成功']: 'Ativado com sucesso',
	['关闭成功']: 'Desativado com sucesso',
	['关闭登入管理模式将会限制客戶藉由输入ID 进入客服，确定要关闭嗎？(若沒有提供客戶Profile资料则会进入错误页面)']: 'Desativar o modo de gestão de login impedirá que clientes acessem o atendimento por ID. Confirma desativar? (Sem perfil do cliente, irá para página de erro)',
	['开启登入管理模式将会開放客戶藉由输入 ID 进入客服，确定要开启嗎？']: 'Ativar o modo de gestão de login permitirá que clientes acessem o atendimento por ID. Confirma ativar?',
	['请输入帐号、昵称、角色等关键字']: 'Insira conta, apelido, perfil ou outras palavras-chave',
	['新增角色']: 'Adicionar perfil',
	['修改角色']: 'Editar perfil',
	['角色创建成功']: 'Perfil criado com sucesso',
	['角色更新成功']: 'Perfil atualizado com sucesso',
	['角色删除成功']: 'Perfil excluído com sucesso',
	['请输入角色名称，平台，权限等关键字']: 'Insira nome do perfil, plataforma, permissões ou outras palavras-chave',
	['关键字']: 'Palavra-chave',
	['角色名称']: 'Nome do perfil',
	['角色名称不可为空']: 'O nome do perfil não pode estar vazio',
	['请输入角色名称']: 'Insira o nome do perfil',
	['上级角色']: 'Perfil superior',
	['上级角色不可为空']: 'O perfil superior não pode estar vazio',
	['权限']: 'Permissões',
	['确定删除此角色?']: 'Confirma excluir este perfil?',
	['图像不能为空']: 'A imagem não pode estar vazia',
	['新增团队']: 'Adicionar equipe',
	['修改团队']: 'Editar equipe',
	['团队创建成功']: 'Equipe criada com sucesso',
	['团队修改成功']: 'Equipe editada com sucesso',
	['团队删除成功']: 'Equipe excluída com sucesso',
	['人数']: 'Quantidade de pessoas',
	['新登入密码']: 'Nova senha',
	['新密码不能设定與舊密码相同']: 'A nova senha não pode ser igual à senha antiga',
	['新密码與確認密码不相同']: 'A nova senha e a confirmação não coincidem',
	['确定修改登入密码?']: 'Confirma alterar a senha?',
	['登入密码修改成功，请重新登入']: 'Senha alterada com sucesso, por favor entre novamente',
	['个人资讯']: 'Informações pessoais',
	['搜寻快捷语']: 'Pesquisar respostas rápidas',
	['登出']: 'Sair',
	['帐密错误']: 'Conta ou senha incorretas',
	['一']: 'uma',
	['二']: 'dois',
	['三']: 'três',
	['四']: 'quatro',
	['五']: 'cinco',
	['六']: 'seis',
	['七']: 'sete',
	['请输入客服本名、客服昵称等关键字']: 'Insira nome real, apelido do atendente ou outras palavras-chave',
	['共 {{count}} 筆资料']: 'Total de {{count}} registros',
	['平台语言不能为空']: 'O idioma da plataforma não pode estar vazio',
	['开启']: 'Abrir',
	['语言']: 'Idioma',
	['切换语言']: 'Alterar idioma',
	['语言名称']: 'Nome do idioma',
	['系统设定']: 'Configurações do sistema',
	['储存成功']: 'Salvo com sucesso',
	['发布成功']: 'Publicado com sucesso',
	['复制成功']: 'Copiado com sucesso',
	['项目选取']: 'Seleção de itens',
	['图像']: 'Imagem',
	['角色']: 'Perfil',
	['新增帐号']: 'Adicionar conta',
	['角色不能为空']: 'O perfil não pode estar vazio',
	['登入密码']: 'Senha de login',
	['请输入代号、名称、备注等关键字']: 'Insira código, nome, observação ou outras palavras-chave',
	['确定删除此团队?']: 'Confirma excluir esta equipe?',
	['切换语言成功']: 'Idioma alterado com sucesso',
	['确定要切换语言?']: 'Confirma alterar o idioma?',
	['选项']: 'Opção',
	['选择语言']: 'Selecionar idioma',
	['修改成功']: 'Editado com sucesso',
	['舊登入密码']: 'Senha antiga',
	['確認新登入密码']: 'Confirmar nova senha',
	['语言切换成功，將重整页面以套用更新']: 'Idioma alterado com sucesso, a página será recarregada',
	['笔 / 页']: 'registros / página',
	['时段搜寻']: 'Pesquisar por período',
	['请选择时段']: 'Selecione o período',
	['更换背景色']: 'Alterar cor de fundo',
	['设定背景颜色成功']: 'Cor de fundo configurada com sucesso',
	['请重新登入']: 'Por favor, entre novamente',
	['绑定谷歌验证']: 'Vincular Google Authenticator',
	['解除绑定']: 'Desvincular',
	['谷歌验证状态']: 'Status do Google Authenticator',
	['已绑定']: 'Vinculado',
	['未绑定']: 'Não vinculado',
	['解绑谷歌验证失败']: 'Falha ao desvincular a autenticação do Google',
	['二维码方式添加']: 'Adicionar via QR Code',
	['请在 Google 身份验证器中采用添加条形码方式添加']: 'Adicione no Google Authenticator usando código de barras',
	['密钥方式添加']: 'Adicionar via chave',
	['请在 Google 身份验证器中采用输入提供的密钥方式添加']: 'Adicione no Google Authenticator inserindo a chave fornecida',
	['密钥如下所示']: 'A chave é a seguinte',
	['请再次输入登入密码']: 'Insira a senha novamente',
	['谷歌6位动态密码']: 'Código dinâmico de 6 dígitos do Google',
	['请绑定谷歌验证']: 'Por favor, vincule o Google Authenticator',
	['谷歌验证绑定成功']: 'Google Authenticator vinculado com sucesso',
	['解绑谷歌验证成功']: 'Google Authenticator desvinculado com sucesso',
	['确定解绑谷歌验证？']: 'Confirma desvincular o Google Authenticator?',
	['请输入谷歌动态码']: 'Insira o código dinâmico do Google',
	['谷歌动态码']: 'Código dinâmico do Google',
	['谷歌动态码不能为空']: 'O código dinâmico não pode estar vazio',
	['谷歌动态码长度6码']: 'O código deve ter 6 dígitos',
	['谷歌动态码错误']: 'Código dinâmico incorreto',
	['內容']: 'Conteúdo',
	['搜寻']: 'Pesquisar',
	['连线中断，点击“确定”即重新连线客服。']: 'Conexão interrompida. Clique em "OK" para reconectar ao atendimento.',
	['充值表单']: 'Formulário de recarga',
	['网银充值']: 'Recarga bancária online',
	['扫码充值']: 'Recarga via QR Code',
	['带入目前帐号']: 'Usar a conta atual',
	['自行输入平台帐号']: 'Insira a conta da plataforma',
	['充值方式']: 'Método de pagamento',
	['平台帐号']: 'Conta de plataforma',
	['充值金额']: 'Valor da recarga',
	['付款人姓名']: 'Nome do pagador',
	['确认语']: 'Mensagem de confirmação',
	['操作时间']: 'Hora da operação',
	['操作者']: 'Operador',
	['请输入备注等关键字']: 'Insira observações ou outras palavras-chave',
	['操作类型']: 'Tipo de operação',
	['修改平台昵称']: 'Editar apelido da plataforma',
	['修改平台昵称成功']: 'Apelido da plataforma editado com sucesso',
	['输入格式错误']: 'Formato de entrada inválido',
	['套用']: 'Aplicar',
	['确定套用到']: 'Confirma aplicar a',
	['套用成功']: 'Aplicado com sucesso',
	['储存方式']: 'Método de armazenamento',
	['储存時間']: 'Tempo de armazenamento',
	['系统发布']: 'Publicado pelo sistema',
	['手动储存']: 'Salvamento manual',
	['自动储存']: 'Salvamento automático',
	['预览']: 'Visualizar',
	['最多350个字']: 'Máximo 350 caracteres',
	['修改']: 'Editar',
	['共同资讯管理']: 'Gestão de informações comuns',
	['共同资讯创建成功']: 'Informação comum criada com sucesso',
	['共同资讯修改成功']: 'Informação comum editada com sucesso',
	['新增共同资讯']: 'Adicionar informação comum',
	['修改共同资讯']: 'Editar informação comum',
	['删除成功']: 'Excluído com sucesso',
	['已设置于其他答案，无法删除']: 'Já configurado em outras respostas, não é possível excluir',
	['请输入名称、内容等关键字']: 'Insira nome, conteúdo ou outras palavras-chave',
	['确定删除此共同资讯？']: 'Confirma excluir esta informação comum?',
	['共同资讯']: 'Informação comum',
	['尚未选择共同资讯']: 'Nenhuma informação comum selecionada',
	['选择共同资讯']: 'Selecionar informação comum',
	['选择']: 'Selecionar',
	['点击「确定」后，即覆盖该平台的快捷语设定']: 'Ao clicar em "OK", as configurações de respostas rápidas desta plataforma serão sobrescritas',
	['已复制：目的平台']: 'Copiado: plataforma de destino',
	['是否离开客服系统？']: 'Deseja sair do sistema de atendimento?',
	['感谢您的作答，此次评分为：{{score}}分']: 'Obrigado pela sua resposta, a pontuação desta vez foi: {{score}} pontos.',
	['共 {{count}} 筆']: 'Total {{count}} registros',
	['分']: 'pontos',
	['新增公司']: 'Adicionar empresa',
	['翻译']: 'Traduzir',
	['显示原文']: 'Original',
	['解绑谷歌验证']: 'Desvincular Google Authenticator',
	['请输入名称 内容等关键字']: 'Insira nome, conteúdo ou outras palavras-chave',
	['表单选项']: 'Opções do formulário',
	['年']: 'Ano',
	['等待时间颜色设定']: 'Configurações de cor do tempo de espera',
	['显示颜色']: 'Cor de exibição',
	['确认删除此规则?']: 'Confirma excluir esta regra?',
	['页签']: 'Aba',
	['超过 {{time}} 分钟']: 'Mais de {{-time}} minutos',
	['新增成功']: 'Adicionado com sucesso',
	['删除完成']: 'Excluído com sucesso',
	['等待时间(分钟)']: 'Tempo de espera (minutos)',
	['时间']: 'Tempo',
	['不可为空']: 'Não pode estar vazio',
	['需为正整数']: 'Deve ser um inteiro positivo',
	['按平台名称排列(A-Z)']: 'Ordenar por nome da plataforma (A-Z)',
	['按平台名称排列(Z-A)']: 'Ordenar por nome da plataforma (Z-A)',
	['旧版面模式']: 'Modo de versão antiga',
	['自动翻译']: 'Tradução automática',
	['功能設定']: 'Configurações de funcionalidade',
	['确认切换版面？']: 'Confirma alterar o layout?',
	['确认开启自动翻译？']: 'Confirma ativar a tradução automática?',
	['确认关闭自动翻译？']: 'Confirma desativar a tradução automática?',
	['原文']: 'Original',
	['泰语']: 'ภาษาไทย',
	['追踪']: 'Seguir',
	['取消追踪']: 'Cancelar seguimento',
	['预览影片']: 'Visualizar vídeo',
	['仅能上传 MP4、MOV、 JPEG (JPG)、PNG、 GIF、HEIC、RAW、HEIF档案']: 'Apenas arquivos MP4, MOV, JPEG (JPG), PNG, GIF, HEIC, RAW, HEIF são permitidos',
	['请勿输入语法相关字串']: 'Não insira caracteres de código ou sintaxe',
	['输入名称']: 'Inserir nome',
	['设为预设版本']: 'Definir como versão padrão',
	['另存为新版本']: 'Salvar como nova versão',
	['请选择版本']: 'Selecione a versão',
	['一键开关']: 'Chave geral',
	['若有服务中的客户，无法关闭服务平台与切换版本']: 'Não é possível fechar a plataforma ou alterar a versão com clientes em atendimento',
	['是否确认要覆盖已有的设定，储存新的设定？']: 'Confirma sobrescrever as configurações existentes e salvar as novas?',
	['已储存超过五个版本']: 'Mais de cinco versões salvas',
	['版本已变动，是否需要储存？']: 'A versão foi alterada, deseja salvar?',
	['确定删除此版本？']: 'Confirma excluir esta versão?',
	['编辑版本']: 'Editar versão',
	['侦测到重复联系客服系统，若非您本人请告知客服']: 'Detectado contato duplicado com o suporte. Se não for você, informe o atendimento.',
	['删除此版本']: 'Excluir esta versão',
	['刪除成功']: 'Excluído com sucesso',
	['刪除失敗']: 'Falha ao excluir',
	['儲存成功']: 'Salvo com sucesso',
	['儲存失敗']: 'Falha ao salvar',
	['您好，请问要选择哪个问题？']: 'Olá, qual assunto você deseja selecionar?',
	['等待服务区']: 'Área de espera',
	['按时间排列(長到短)']: 'Ordenar por tempo (mais longo a mais curto)',
	['按时间排列(短到長)']: 'Ordenar por tempo (mais curto a mais longo)',
	['亲, 欢迎您的到来～很高兴为您服务，请先别著急，我们即将为您提供服务 ...']: 'Olá, seja bem-vindo! É um prazer atendê-lo. Por favor, aguarde um momento, em breve iremos atendê-lo...',
	['编辑标签']: 'Editar etiqueta',
	['于 {{time}} 侦测到会员【稍早已离线】']: 'Membro detectado como【já offline】em {{-time}}',
	['{{score}}分']: '{{score}} pontos',
	['未评分']: 'Não avaliado',
	['客服完成']: 'Concluído pelo atendente',
	['会员离线']: 'Membro offline',
	['超时自动断线']: 'Desconexão automática por timeout',
	['{{text}}不可重复']: '{{-text}} não pode se repetir',
	['{{text}}不能为空']: '{{-text}} não pode estar em branco',
	['{{text}}设置错误']: 'Erro de configuração de {{-text}}',
	['平均通话时长']: 'Duração média de chamada',
	['平均通话数']: 'Número médio de chamadas',
	['请选择角色名称']: 'Selecione o nome do perfil',
	['请选择客服']: 'Selecione o atendente',
	['请选择团队']: 'Selecione a equipe',
	['播放']: 'Reproduzir',
	['统计时间']: 'Hora da estatística',
	['统计时间不可为空']: 'A hora da estatística não pode estar vazia',
	['请输入时间']: 'Insira o tempo',
	['时间筛选']: 'Filtro de tempo',
	['汇出']: 'Exportar',
	['未出勤']: 'Ausente',
	['客服平均通话时长']: 'Duração média de chamada do atendente',
	['数量筛选']: 'Filtro de quantidade',
	['客服平均等待时间']: 'Tempo médio de espera do atendente',
	['上一个月']: 'Mês anterior',
	['导出Excel成功']: 'Exportação para Excel concluída',
	['对话结束']: 'Conversa encerrada',
	['满意度/客服']: 'Satisfação/Atendente',
	['日期/客服']: 'Data/Atendente',
	['总数']: 'Total',
	['日平均']: 'Média diária',
	['客服日均量']: 'Volume médio diário do atendente',
	['客服通话总量']: 'Total de chamadas do atendente',
	['日总量']: 'Total diário',
	['请输入数量']: 'Insira a quantidade',
	['满意度预设分数']: 'Pontuação padrão de satisfação',
	['当会员未评分，会自动给予此预设分数。']: 'Quando o membro não avalia, esta pontuação padrão é atribuída automaticamente.',
	['设定满意度预设分数成功']: 'Pontuação padrão de satisfação configurada com sucesso',
	['客户满意度管理']: 'Gestão de satisfação do cliente',
	['对话结束方式']: 'Forma de encerramento da conversa',
	['对话满意度']: 'Satisfação da conversa',
	['时段']: 'Período',
	['客服平均满意度']: 'Satisfação média do atendente',
	['公用设定']: 'Configurações comuns',
	['通话时长']: 'Duração da chamada',
	['服务时段']: 'Período de atendimento',
	['储存时间']: 'Tempo de armazenamento',
	['客服不可为空']: 'O atendente não pode estar vazio',
	['团队不可为空']: 'A equipe não pode estar vazia',
	['请输入对话内容关键字']: 'Insira palavras-chave do conteúdo da conversa',
	['请输入客服本名、昵称或帐号']: 'Insira nome real, apelido ou conta do atendente',
	['平台不可为空']: 'A plataforma não pode estar vazia',
	['线上']: 'Online',
	['离线']: 'Offline',
	['日期不可为空']: 'A data não pode estar vazia',
	['亲，跟您再次确认下，申请并进行此笔充值 {{chargeNumber}} 元的帐号是 {{chargeAccount}}，对吗？']: 'Olá, gostaria de confirmar novamente. A conta que está solicitando esta recarga de {{chargeNumber}} é {{chargeAccount}}, correto?',
	['您的等待顺位为第 {{pendingOrder}} 位']: 'Sua posição na fila é a nº {{pendingOrder}}.',
	['拒絕由 {{inviter}} 转接至 {{invitee}}']: 'Transferência de {{-inviter}} para {{-invitee}} recusada',
	['{{name}} 已于 {{time}} 关闭视窗']: '{{-name}} fechou a janela às {{-time}}',
	['{{name}} 已于 {{time}} 点选案件完成']: '{{-name}} marcou o caso como concluído às {{-time}}',
	['{{name}} 已于 {{time}} 成功加入协作']: '{{-name}} entrou na colaboração às {{-time}}',
	['{{name}} 已于 {{time}} 离开协作']: '{{-name}} saiu da colaboração às {{-time}}',
	['{{name}} 已于 {{time}} 中断连线']: '{{-name}} desconectou às {{-time}}',
	['英文']: 'English',
	['验证码设定']: 'Configurações de captcha',
	['启用验证码']: 'Ativar captcha',
	['设定验证码成功']: 'Captcha configurado com sucesso',
	['启用验证码功能后，客户需完成验证才能进入客服系统等待区。']: 'Após ativar o captcha, os clientes precisam completar a verificação para acessar a área de espera.',
	['禁止连续发话']: 'Proibido enviar mensagens consecutivas',
	['启用禁止连续发话']: 'Ativar bloqueio de mensagens consecutivas',
	['当会员在「限制秒数」内发话超过设定的次数，系统将会自动跳警告。']: 'Quando o membro fala mais que o limite definido em "segundos restritos", o sistema emite um aviso automaticamente.',
	['客户端限制于']: 'Cliente limitado a',
	['发话次数达到']: 'Número de mensagens atinge',
	['次']: 'vezes',
	['暂时无法发话']: 'Temporariamente não pode falar',
	['储存完成']: 'Salvamento concluído',
	['发送消息过于频繁 可稍后再试']: 'Mensagens enviadas com muita frequência, tente novamente mais tarde',
	['IP黑名单管理']: 'Gestão de lista negra de IP',
	['共 {{total}} 笔']: 'Total {{total}} registros',
	['第 {{min}} - {{max}} 笔/共 {{total}} 笔']: '{{min}} - {{max}} de {{total}}',
	['顯示']: 'Exibir',
	['查询IP黑名单']: 'Consultar lista negra de IP',
	['设定自动添加黑名单']: 'Configurar adição automática à lista negra',
	['白名單管理']: 'Gestão de lista branca',
	['解除时间']: 'Tempo de liberação',
	['永久封锁']: 'Bloqueio permanente',
	['新增IP黑名单']: 'Adicionar à lista negra de IP',
	['加入黑名单后，该IP将无法进入客服前台。']: 'Após adicionar à lista negra, este IP não poderá acessar o atendimento.',
	['请完成安全验证']: 'Por favor, complete a verificação de segurança',
	['向右滑动填充拼图']: 'Deslize para a direita para completar o quebra-cabeça',
	['启用功能']: 'Ativar função',
	['若IP于「限制时间」内登入超过设定的「登入次数」系统即自动加入黑名单。']: 'Se o IP exceder o número de logins definido dentro do "tempo limite", será automaticamente adicionado à lista negra.',
	['限制时间']: 'Tempo limite',
	['时间单位不可为空']: 'A unidade de tempo não pode estar vazia',
	['时间单位']: 'Unidade de tempo',
	['登入次数']: 'Número de logins',
	['封锁时间']: 'Tempo de bloqueio',
	['锁的持续时间，时间到了会自动解除']: 'Duração do bloqueio, será liberado automaticamente ao final',
	['查询IP白名单']: 'Consultar lista branca de IP',
	['删除失败']: 'Falha ao excluir',
	['修改失败']: 'Falha ao editar',
	['拼图验证失败次数过多']: 'Muitas falhas na verificação do quebra-cabeça',
	['{{name}} 已于 {{time}} 拒絕加入协作']: '{{-name}} recusou entrar na colaboração às {{-time}}',
	['储存过滤模組成功']: 'Módulo de filtro salvo com sucesso',
	['删除过滤模組成功']: 'Módulo de filtro excluído com sucesso',
	['解除谷歌验证成功']: 'Google Authenticator removido com sucesso',
	['确定禁用平台?']: 'Confirma desativar a plataforma?',
	['确定启用平台?']: 'Confirma ativar a plataforma?',
	['IP管理(客户端)']: 'Gestão de IP (cliente)',
	['上传']: 'Enviar',
	['此栏位的时间会使用于报表的团队筛选']: 'O tempo deste campo será usado para filtro de equipe nos relatórios',
	['选择团队：筛选出该团队所有客服人员在团队统计时间中的数据']: 'Selecionar equipe: filtra dados de todos os atendentes da equipe no período estatístico',
	['备注最多{{inputLimit}}个字']: 'Observação no máximo {{inputLimit}} caracteres',
	['{{inviter}} 已于 {{time}} 将对话从 {{from}} 转接给 {{invitee}}']: '{{-inviter}} transferiu a conversa de {{-from}} para {{-invitee}} às {{-time}}',
	['小时']: 'hora',
	['日']: 'dia',
	['会员IP：{{ip}} 已加入前台黑名单']: 'IP do membro: {{ip}} adicionado à lista negra do front-end',
	['新增失败']: 'Falha ao adicionar',
	['会员IP被加入黑名单']: 'IP do membro adicionado à lista negra',
	['登入/接待时间']: 'Tempo de login/atendimento',
	['timePeriodTooltipMessage']: 'Tooltip do período de tempo',
	['平均接待时间']: 'Tempo médio de atendimento',
	['平均登入时间']: 'Tempo médio de login',
	['接待时间报表']: 'Relatório de tempo de atendimento',
	['登入时间报表']: 'Relatório de tempo de login',
	['未登入']: 'Não conectado',
	['设定报表']: 'Configurar relatório',
	['设定对话是否记入报表中']: 'Definir se a conversa é registrada no relatório',
	['平均通话时长报表']: 'Relatório de duração média de chamada',
	['平均通话数报表']: 'Relatório de número médio de chamadas',
	['平均等待时间报表']: 'Relatório de tempo médio de espera',
	['客户满意度报表']: 'Relatório de satisfação do cliente',
	['平均回覆时间报表']: 'Relatório de tempo médio de resposta',
	['调整原因']: 'Motivo do ajuste',
	['请输入调整原因']: 'Insira o motivo do ajuste',
	['调整原因不可为空']: 'O motivo do ajuste não pode estar vazio',
	['日期时间']: 'Data e hora',
	['操作人']: 'Operador',
	['原因']: 'Motivo',
	['更多']: 'Mais',
	['收回']: 'Retirar',
	['设定报表成功']: 'Relatório configurado com sucesso',
	['平均回覆时间']: 'Tempo médio de resposta',
	['客服平均回覆时间']: 'Tempo médio de resposta do atendente',
	['客户回头率']: 'Taxa de retorno do cliente',
	['客户ID']: 'ID do cliente',
	['客服帐号']: 'Conta do atendente',
	['小时回头率']: 'Taxa de retorno por hora',
	['日回头率']: 'Taxa de retorno diária',
	['遗漏时间']: 'Tempo perdido',
	['请选择遗漏时间']: 'Selecione o tempo perdido',
	['平均遗漏时间']: 'Tempo médio perdido',
	['1分钟']: '1 minuto',
	['2分钟']: '2 minutos',
	['3分钟']: '3 minutos',
	['4分钟']: '4 minutos',
	['5分钟']: '5 minutos',
	['离开时间']: 'Hora de saída',
	['客户回头率报表']: 'Relatório de taxa de retorno do cliente',
	['平台报表']: 'Relatório da plataforma',
	['对话总量']: 'Total de conversas',
	['接待总量']: 'Total de atendimentos',
	['遗漏总量']: 'Total perdido',
	['智能客服总量']: 'Total do atendimento inteligente',
	['智能转客服总量']: 'Total transferido do inteligente para humano',
	['最后更新时间']: 'Última atualização',
	['客服人数']: 'Número de atendentes',
	['在线客服总数']: 'Total de atendentes online',
	['等待服务']: 'Aguardando atendimento',
	['正在服务']: 'Em atendimento',
	['智能未转客服总量']: 'Total do inteligente não transferido',
	['使用平台']: 'Plataforma usada',
	['泰文名称']: 'Nome em tailandês',
	['请输入泰文名称']: 'Insira o nome em tailandês',
	['英文名称']: 'Nome em inglês',
	['请输入英文名称']: 'Insira o nome em inglês',
	['中文名称']: 'Nome em chinês',
	['请输入中文名称']: 'Insira o nome em chinês',
	['若无需翻译请填写中文']: 'Se não precisar traduzir, preencha em chinês',
	['帐号所有报表数据将连同帐号一同删除，请问确认要删除吗？']: 'Todos os dados de relatórios da conta serão excluídos junto com a conta. Confirma a exclusão?',
	['停用']: 'Desativar',
	['停用帐号']: 'Desativar conta',
	['通话总数']: 'Total de chamadas',
	['等待中人数：{{pendingConversationCount}} 人']: 'Aguardando: {{pendingConversationCount}} pessoas',
	['报表正在汇出中，请前往页面「报表下载」查看进度并进行下载。']: 'Relatório sendo exportado, acesse "Download de relatórios" para ver o progresso e baixar.',
	['汇出Load Data']: 'Exportar Load Data',
	['报表下载']: 'Download de relatórios',
	['全平台']: 'Todas as plataformas',
	['报表类型']: 'Tipo de relatório',
	['数据范围']: 'Intervalo de dados',
	['汇出时间']: 'Hora de exportação',
	['完成时间']: 'Hora de conclusão',
	['申请者']: 'Solicitante',
	['下载']: 'Baixar',
	['重新汇出']: 'Re-exportar',
	['处理中']: 'Processando',
	['已完成']: 'Concluído',
	['失败']: 'Falhou',
	['下载成功']: 'Download concluído',
	['历史对话纪录']: 'Histórico de conversas',
	['连线中断，请点击确定尝试恢复连线，若无法恢复将结束对话。']: 'Conexão interrompida. Clique em OK para tentar reconectar. Se falhar, a conversa será encerrada.',
	['引用功能管理']: 'Gestão de função de citação',
	['引用对话']: 'Citar conversa',
	['设定引用对话成功']: 'Função de citação configurada com sucesso',
	['客户管理']: 'Gestão de clientes',
	['重要客户帐号']: 'Conta de cliente importante',
	['请输入重要客户帐号、备注等关键字']: 'Insira conta de cliente importante, observação ou outras palavras-chave',
	['新增重要客户']: 'Adicionar cliente importante',
	['重要客户帐号不能为空']: 'A conta do cliente importante não pode estar vazia',
	['输入多个帐号请用, 区隔']: 'Para múltiplas contas, separe com vírgulas',
	['修改重要客户']: 'Editar cliente importante',
	['重要帐号']: 'Conta importante',
	['会员类型']: 'Tipo de membro',
	['引用']: 'Citar',
	['收回(訊息)']: 'Retirar (mensagem)',
	['收回功能管理']: 'Gestão de função de retirada',
	['收回提示文字不能为空']: 'O texto de aviso de retirada não pode estar vazio',
	['收回对话']: 'Retirar conversa',
	['收回提示文字（中文）']: 'Texto de aviso de retirada (chinês)',
	['收回提示文字（英文）']: 'Texto de aviso de retirada (inglês)',
	['收回提示文字（泰文）']: 'Texto de aviso de retirada (tailandês)',
	['视频']: 'Vídeo',
	['确定要收回讯息吗？']: 'Confirma retirar a mensagem?',
	['设定收回功能成功']: 'Função de retirada configurada com sucesso',
	['遗漏数据']: 'Dados perdidos',
	['全选']: 'Selecionar todos',
	['请选择使用平台']: 'Selecione a plataforma de uso',
	['日期计算方式']: 'Método de cálculo de data',
	['以会员进入正在服务区的时间计算']: 'Calcular pelo tempo de entrada na área de atendimento',
	['以会员进入等待服务区的时间计算，若是点击智能客服未进入等待服务区则以点入智能客服的时间计算']: 'Calcular pelo tempo de entrada na área de espera; se clicou no atendimento inteligente sem entrar na espera, calcular pelo clique no inteligente',
	['以会员进入等待服务区的时间计算']: 'Calcular pelo tempo de entrada na área de espera',
	['以客服接通对话的时间进行计算']: 'Calcular pelo tempo de conexão do atendente',
	['以会员进入等待服务区的时间进行计算']: 'Calcular pelo tempo de entrada na área de espera',
	['以会员点击智能客服的时间计算']: 'Calcular pelo tempo de clique no atendimento inteligente',
	['相同类型才会计算回头']: 'Apenas o mesmo tipo conta como retorno',
	['登入联系离开后再次登入联系']: 'Login - contato - saída - login novamente - contato',
	['一通对话只会触发一次回头次数']: 'Uma conversa aciona apenas uma contagem de retorno',
	['同一会员时间内连续联系3次，计算前两通对话的客服各1次回头']: 'Mesmo membro com 3 contatos consecutivos: as duas primeiras conversas contam 1 retorno cada para os atendentes',
	['每日同一会员于对话结束后{{hour}}小时内又重复联系的有效对话比例']: 'Proporção diária de conversas válidas em que o mesmo membro contata novamente em até {{-hour}} horas após o término',
	['未登入联系离开后再次未登入联系']: 'Sem login - contato - saída - sem login novamente - contato',
	['请输入重要客户帐号']: 'Insira a conta do cliente importante',
	['开始日期']: 'Data inicial',
	['结束日期']: 'Data final',
	['标签名称/数量']: 'Nome da etiqueta/Quantidade',
	['暂无数据']: 'Sem dados',
	['AI客服设定']: 'Configurações do Atendimento IA',
	['AI共同设定']: 'Configurações comuns da IA',
	['平台AI设定']: 'Configurações IA da plataforma',
	['平台 AI SKILL 设定']: 'Configurações IA SKILL da plataforma',
	['指令输入说明']: 'Instruções de entrada do comando',
	['输入文字档']: 'Inserir arquivo de texto',
	['不需要区分功能']: 'Não precisa diferenciar funções',
	['套用平台']: 'Aplicar à plataforma',
	['请输入指令']: 'Insira o comando',
	['AI与会员对话超过 <<inputNumber>> 轮后需要通知客服人员']: 'Após mais de <<inputNumber>> turnos de conversa entre IA e membro, notificar o atendente',
	['指令']: 'Comando',
	['AI开关']: 'Interruptor da IA',
	['AI客服名称']: 'Nome do Atendimento IA',
	['AI客服名称不能为空']: 'O nome do Atendimento IA não pode estar vazio',
	['请输入AI客服名称']: 'Insira o nome do Atendimento IA',
	['是否要关闭AI客服？关闭后将无法再度开启AI客服']: 'Deseja desativar o Atendimento IA? Após desativar, não será possível reativá-lo',
	['侦测到对话有异常状态，请尽快处理']: 'Detectado status anormal na conversa, resolva o mais rápido possível',
	['需要转接人工客服，请尽快处理']: 'Transferência para atendente humano necessária, processar imediatamente',
	['总平均通话时长']: 'Duração média total de chamada',
	['AI平均通话时长']: 'Duração média de chamada IA',
	['人工平均通话时长']: 'Duração média de chamada humana',
	['每日总平均']: 'Média diária total',
	['AI日平均']: 'Média diária IA',
	['人工日平均']: 'Média diária humana',
	['通话总量']: 'Total de chamadas',
	['AI通话总量']: 'Total de chamadas IA',
	['共同']: 'Comum',
	['总计']: 'Total',
	['总计请勿超过{{limit}}字']: 'Total não pode exceder {{-limit}} caracteres',
	['总平均回覆时间']: 'Tempo médio total de resposta',
	['AI平均回覆时间']: 'Tempo médio de resposta IA',
	['人工平均回覆时间']: 'Tempo médio de resposta humana',
	['AI日总量']: 'Total diário IA',
	['人工日总量']: 'Total diário humano',
	['指令不能为空']: 'O comando não pode estar vazio',
	['{{name}} 已于 {{time}} 开启AI']: '{{-name}} ativou a IA às {{-time}}',
	['{{name}} 已于 {{time}} 关闭AI']: '{{-name}} desativou a IA às {{-time}}',
	['人机合作日总量']: 'Total diário de cooperação humano-máquina',
	['人工通话总量']: 'Total de chamadas humanas',
	['人机合作通话总量']: 'Total de chamadas de cooperação humano-máquina',
	['以对话建立时间计算']: 'Calcular pelo tempo de criação da conversa',
	['侦测到对话有异常状态 - 对话次数超过限制']: 'Detectado status anormal na conversa - Limite de mensagens excedido',
	['侦测到对话有异常状态 - 系统发生错误']: 'Detectado status anormal na conversa - Erro no sistema',
	['人机合作-人工日平均']: 'Cooperação humano-máquina - Média diária humana',
	['人机合作-AI日平均']: 'Cooperação humano-máquina - Média diária IA',
	['人机合作-人工平均通话时长']: 'Cooperação humano-máquina - Duração média de chamada humana',
	['人机合作-AI平均通话时长']: 'Cooperação humano-máquina - Duração média de chamada IA',
	['侦测到对话有异常状态 - 等待AI API超过两分钟']: 'Detectado status anormal na conversa - Espera da API IA excedeu 2 minutos',
	['侦测到对话有异常状态 - AI 发生错误']: 'Detectado status anormal na conversa - Erro no IA',
	['侦测到对话有异常状态 - AI 没有回复']: 'Detectado status anormal na conversa - IA não responde',
	['数据']: 'Dados',
	['指令不能超过{{limit}}字']: 'O comando não pode exceder {{-limit}} caracteres',
	['数据不能为空']: 'Os dados não podem estar vazios',
	['数据不能超过100万字']: 'Os dados não podem exceder 1 milhão de caracteres',
	['需{{limit}}字以内']: 'Dentro de {{-limit}} caracteres',
	['数据输入说明']: 'Instruções de entrada de dados',
	['需100万字以内']: 'Dentro de 1 milhão de caracteres',
	['至少要有一组 ~~~~~ 与 =====']: 'Deve conter pelo menos um par de ~~~~~ e =====',
	['分隔符号 ~~~~~ 与 ===== 需成对出现']: 'Os separadores ~~~~~ e ===== devem aparecer em pares',
	['需以 ===== 结尾']: 'Deve terminar com =====',
	['标题底下使用5个波浪号并换行，波浪号的开头与结尾不能有其他文字或空格']: 'Coloque 5 tis na linha abaixo do título, sem outro texto ou espaço antes ou depois',
	['内容底下使用5个等号并换行，等号的开头与结尾不能有其他文字或空格']: 'Coloque 5 sinais de igual na linha abaixo do conteúdo, sem outro texto ou espaço antes ou depois',
	['范例']: 'Exemplo',
	['标题A（可多行）']: 'Título A (várias linhas permitidas)',
	['内容A（可多行，可含任何文字）']: 'Conteúdo A (várias linhas, qualquer texto permitido)',
	['标题B（可多行）']: 'Título B (várias linhas permitidas)',
	['内容B（可多行，可含任何文字）']: 'Conteúdo B (várias linhas, qualquer texto permitido)',
	['模型顺序（上方模型优先使用，失效时自动往下切换）']: 'Ordem dos modelos (o modelo superior é usado primeiro; em caso de falha, muda automaticamente para o próximo)',
	['主要']: 'Principal',
	['备援{{index}}']: 'Reserva {{index}}',
	['新增备援模型']: 'Adicionar modelo de reserva',
	['请输入数据']: 'Insira os dados',
	['正在转接中...']: 'Transferindo...',
	['（中文）']: '(chinês)',
	['（英文）']: '(inglês)',
	['（泰文）']: '(tailandês)',
	['（越南文）']: '(vietnamita)',
	['越南文名称']: 'Nome em vietnamita',
	['请输入越南文名称']: 'Insira o nome em vietnamita',
	['模式']: 'Modo',
	['越南语']: 'Tiếng Việt',
	['IP白名单设定']: 'Configurações de lista branca de IP',
	['建立时间']: 'Data de criação',
	['批次删除']: 'Excluir em lote',
	['请确认是否删除 IP 白名单？']: 'Confirma excluir a lista branca de IP?',
	['开启快捷选单']: 'Abrir menu rápido',
	['收合快捷选单']: 'Fechar menu rápido',
	['是否有收回人员讯息']: 'Mensagem do atendente foi retirada?',
	['是否有收回AI讯息']: 'Mensagem da IA foi retirada?',
	['消息已被客服撤回']: 'Mensagem retirada pelo atendente',
	['用户快捷选单管理']: 'Gestão do menu rápido do usuário',
	['电脑预览']: 'Visualização no computador',
	['手机预览']: 'Visualização no celular',
	['档案格式：PNG、JPG、JPEG']: 'Formato: PNG, JPG, JPEG',
	['请选择上传档案']: 'Por favor, selecione um arquivo para enviar',
	['新增快捷成功']: 'Atalho adicionado com sucesso',
	['修改快捷成功']: 'Atalho editado com sucesso',
	['设定快捷选单成功']: 'Menu rápido configurado com sucesso',
	['删除快捷成功']: 'Atalho excluído com sucesso',
	['确定删除此快捷？']: 'Confirma excluir este atalho?',
	['新增内容']: 'Adicionar conteúdo',
	['选项內容']: 'Conteúdo da opção',
	['{{itemLabel}}內容不能为空']: 'O conteúdo de {{-itemLabel}} não pode estar vazio',
	['请输入{{itemLabel}}标题']: 'Insira o título de {{-itemLabel}}',
	['请输入{{itemLabel}}选项']: 'Insira a opção de {{-itemLabel}}',
	['{{text}}不可为空']: '{{-text}} não pode estar vazio',
	['显示更多']: 'Mostrar mais',
	['公告标签']: 'Etiqueta de anúncio',
	['请选择公告标签']: 'Selecione a etiqueta de anúncio',
	['{{text}}标题']: 'Título de {{-text}}',
	['{{text}}內文']: 'Conteúdo de {{-text}}',
	['{{text}}最多{{inputLimit}}个字']: '{{-text}} máximo {{inputLimit}} caracteres',
	['公告内文档案大小总计不得大于10MB']: 'O tamanho total dos arquivos do anúncio não pode exceder 10MB',
	['用户尚未离开，确认要完成对话？']: 'O usuário ainda não saiu, confirma encerrar a conversa?',
	['{{name}} 已于 {{time}} 离开对话']: '{{-name}} saiu da conversa às {{-time}}',
	['客服人员']: 'Atendente',
	['*新增多个IP请使用逗号「 , 」隔开']: '*Para adicionar múltiplos IPs, separe-os com vírgula " , "',
	['是否新增IP白名单？']: 'Adicionar à lista branca de IP?',
	['IP已存在']: 'IP já existe',
	['监控区管理']: 'Gestão da área de monitorização',
	['监控区开关']: 'Interruptor da área de monitorização',
	['设定监控区开关成功']: 'Interruptor da área de monitorização configurado com sucesso',
	['启用功能后，等待服务区会增加一个[监控区]页签，显示全平台被AI拦截的对话与未读时间最长的5通对话，点击可快速跳转至相应对话。']: 'Após ativar a função, será adicionado um separador [Área de monitorização] na área de espera, exibindo as conversas interceptadas pela IA em toda a plataforma e as 5 conversas não lidas há mais tempo. Clique para ir rapidamente à conversa correspondente.',
	['{{name}} 新增了标签 {{tag}}']: '{{-name}} adicionou a etiqueta {{-tag}}',
	['{{name}} 移除了标签 {{tag}}']: '{{-name}} removeu a etiqueta {{-tag}}',
	['状态切换为暂离']: 'Status alterado para ausente',
	['状态切换为工作中']: 'Status alterado para trabalhando',
	['监控区']: 'Área de monitorização',
	['自动接线管理']: 'Gestão de atendimento automático',
	['客服全平台接待数量达到上限后，系统不会自动接入等待服务区的对话，客服人员手动接入数量不限制。']: 'Quando o atendente atinge o limite de atendimentos na plataforma, o sistema não conecta automaticamente conversas da área de espera; não há limite para conexões manuais.',
	['自动接线数量上限']: 'Limite máximo de atendimento automático',
	['设定自动接线成功']: 'Atendimento automático configurado com sucesso',
	['{{name}} 进线']: '{{-name}} entrou',
	['工作/暂离时间']: 'Tempo de trabalho/ausência',
	['工作时长报表']: 'Relatório de tempo de trabalho',
	['暂离时长报表']: 'Relatório de tempo de ausência',
	['平均工作时长']: 'Duração média de trabalho',
	['平均暂离时长']: 'Duração média de ausência',
	['关键字提醒']: 'Aviso de palavra-chave',
	['客户发话']: 'Cliente falou',
	['AI发话']: 'IA falou',
	['发话来源']: 'Origem da fala',
	['请输入发话来源、关键字']: 'Insira a origem da fala ou palavras-chave',
	['新增关键字']: 'Adicionar palavra-chave',
	['修改关键字']: 'Editar palavra-chave',
	['新增关键字成功']: 'Palavra-chave adicionada com sucesso',
	['修改关键字成功']: 'Palavra-chave editada com sucesso',
	['删除关键字成功']: 'Palavra-chave excluída com sucesso',
	['是否删除此关键字？']: 'Excluir esta palavra-chave?',
	['请用「；」来分隔不同关键字，关键字不得超过100个字']: 'Use ";" para separar palavras-chave diferentes, máximo 100 caracteres por palavra-chave',
	['客户触发关键字 [{{word}}] 请客服人员注意']: 'Cliente acionou palavra-chave [{{-word}}], atendente atenção',
	['AI触发关键字 [{{word}}] 请客服人员注意']: 'IA acionou palavra-chave [{{-word}}], atendente atenção',
	['请输入通知时间']: 'Insira o tempo de notificação',
	['自动接线开关']: 'Interruptor de atendimento automático',
	['自动接线数量上限不可为空']: 'O limite de atendimento automático não pode estar vazio',
	['请输入数量上限']: 'Insira o limite de quantidade',
	['离开状态侦测开关']: 'Interruptor de detecção de status ausente',
	['开启后当客服人员为平台最后一个工作状态或仍有接待中且无协作给他人对话时，无法切换为离开状态。']: 'Após ativar, quando o atendente é o último em trabalho na plataforma ou ainda tem atendimentos sem colaboração transferida, não pode mudar para ausente.',
	['离开时间通知开关']: 'Interruptor de notificação de tempo ausente',
	['通知时间不可重复']: 'Os tempos de notificação não podem repetir',
	['侦测权限CS帐号离开时间，离开时间达设定时间时通知权限manager以上的帐号，以及触发离开时间的CS帐号本人。']: 'Detecta o tempo ausente de contas CS; quando atinge o tempo definido, notifica contas com permissão manager ou superior, e a própria conta CS que acionou.',
	['最后暂离时间报表']: 'Relatório do último tempo ausente',
	['平均最后暂离时间']: 'Tempo médio do último ausente',
	['{{name}} 离开时间已达 [{{minute}}] 分钟 !']: 'Tempo ausente de {{-name}} atingiu [{{minute}}] minutos!',
	['历史对话记录下载']: 'Download do histórico de conversas',
	['使用模式']: 'Modo de uso',
	['标准模式']: 'Modo padrão',
	['ID模式']: 'Modo ID',
	['即进模式']: 'Modo de entrada direta',
	['复制即进网址']: 'Copiar URL de entrada direta',
	['生成新网址']: 'Gerar nova URL',
	['需提供客户Profile资料的标准模式，此模式为系统预设模式。']: 'Modo padrão que requer dados do perfil do cliente, este é o modo padrão do sistema.',
	['输入ID 进入客服，可不提供客戶Profile资料。']: 'Inserir ID para acessar o atendimento, sem necessidade de perfil do cliente.',
	['透过即进网址可直接进入客服系统，无需提供资料，系统自动给予随机访客名称。']: 'Via URL de entrada direta, acesso direto ao sistema, sem necessidade de dados, o sistema atribui nome de visitante aleatório.',
	['请再次确认是否從 [<<prevTypeText>>] 切至 [<<nextTypeText>>]']: 'Confirma alterar de [<<prevTypeText>>] para [<<nextTypeText>>]?',
	['以下是即进网址']: 'Abaixo a URL de entrada direta',
	['复制网址']: 'Copiar URL',
	['使用模式切换成功']: 'Modo de uso alterado com sucesso',
	['请再次确认是否更换网址 ，一经更换<<redText>>']: 'Confirma alterar a URL? Uma vez alterada <<redText>>',
	['当前即进网址']: 'URL atual',
	['新即进网址']: 'Nova URL',
	['复制即进网址成功']: 'URL copiada com sucesso',
	['报表统计']: 'Estatísticas do relatório',
	['操作時間']: 'Hora da operação',
	['统计类型']: 'Tipo de estatística',
	['请选择统计类型']: 'Selecione o tipo de estatística',
	['查询参数']: 'Parâmetros de consulta',
	['申请时间']: 'Hora da solicitação',
	['产出时间']: 'Hora de geração',
	['申请帐号']: 'Conta solicitante',
	['详细资料']: 'Detalhes',
	['重新执行统计']: 'Re-executar estatística',
	['执行统计']: 'Executar estatística',
	['登入时间范围']: 'Intervalo de tempo de login',
	['选择团队：筛选出该团队所有客服人员']: 'Selecionar equipe: filtra todos os atendentes da equipe',
	['API接收日志']: 'Log de recebimento de API',
	['新增来源']: 'Adicionar origem',
	['CS']: 'CS',
	['包网']: 'Plataforma',
	['包网API']: 'API da Plataforma',
	['第 {{min}} - {{max}} 笔']: '{{-min}} - {{-max}} registros',
	['选择的日期区间需小于等于{{limit}}天']: 'O intervalo de datas selecionado deve ser menor ou igual a {{-limit}} dias',
	['请选择日期时间查询条件']: 'Selecione as condições de consulta de data e hora',
	['类型']: 'Tipo',
	['公司']: 'Empresa',
	['请输入公司']: 'Insira a empresa',
	['会员帐号']: 'Conta do membro',
	['请输入会员帐号']: 'Insira a conta do membro',
	['是否查看详细资料？']: 'Ver detalhes?',
	['传送资料']: 'Enviar dados',
	['CS回覆资料']: 'Dados de resposta CS',
	['内容']: 'Conteúdo',
	['请选择进入的公司']: 'Selecione a empresa de entrada',
	['指令数据更新纪录']: 'Registro de atualização de dados de comando',
	['1.排序机制：所有公司的指令将统一排序处理，确保系统高效运作。']: '1. Mecanismo de ordenação: comandos de todas as empresas serão ordenados de forma unificada para garantir eficiência do sistema.',
	['2.数据隔离：用户仅能查看自己公司的更新记录，无法查看其他公司的记录。']: '2. Isolamento de dados: usuários só podem ver registros de atualização da própria empresa.',
	['微调训练']: 'Treinamento de ajuste fino',
	['执行微调']: 'Executar ajuste fino',
	['操作帐号']: 'Conta operadora',
	['是否修改AI API?']: 'Alterar IA API?',
	['保存设置']: 'Salvar configurações',
	['修改AI API成功']: 'IA API editada com sucesso',
	['请输入{{text}}']: 'Por favor, insira {{-text}}',
	['{{text}}不能超过{{limit}}字元']: '{{-text}} não pode exceder {{-limit}} caracteres',
	['AI API']: 'IA API',
	['微调训练记录']: 'Registro de treinamento de ajuste fino',
	['模型名称']: 'Nome do modelo',
	['新增文本']: 'Adicionar texto',
	['修改文本']: 'Editar texto',
	['请输入名称']: 'Insira o nome',
	['取消修改微调文本']: 'Cancelar edição do texto de ajuste fino',
	['角色不可为空']: 'O perfil não pode estar vazio',
	['请选择角色']: 'Selecione o perfil',
	['内容不可为空']: 'O conteúdo não pode estar vazio',
	['请输入内容']: 'Insira o conteúdo',
	['系统']: 'Sistema',
	['会员']: 'Membro',
	['AI']: 'IA',
	['请确认是否取消？']: 'Confirma cancelar?',
	['新增微调文本成功']: 'Texto de ajuste fino adicionado com sucesso',
	['修改微调文本成功']: 'Texto de ajuste fino editado com sucesso',
	['自定模型名称']: 'Nome do modelo personalizado',
	['微调确认讯息']: 'Mensagem de confirmação de ajuste fino',
	['请确认是否执行微调训练？']: 'Confirma executar o treinamento de ajuste fino?',
	['删除微调文本']: 'Excluir texto de ajuste fino',
	['请确认是否刪除？']: 'Confirma excluir?',
	['刪除微调文本成功']: 'Texto de ajuste fino excluído com sucesso',
	['请输入模型名称']: 'Insira o nome do modelo',
	['执行微调成功']: 'Ajuste fino executado com sucesso',
	['取消修改文本成功']: 'Edição de texto cancelada com sucesso',
	['取消新增文本成功']: 'Adição de texto cancelada com sucesso',
	['您已成功登出客服系统。']: 'Você saiu do sistema de atendimento com sucesso.',
	['如需重新登录，请返回包网！']: 'Para entrar novamente, retorne à plataforma!',
	['您已成功登出客服系统管理端。']: 'Você saiu do console de administração com sucesso.',
	['当「平均等待时间」显示为 0 秒时，可能的原因如下：']: 'Quando o "tempo médio de espera" mostra 0 segundos, as possíveis razões são:',
	['1.当日所有对话的等待时间均为 0 秒（例如因自动接线或即时应答，无需等待）。']: '1. Todas as conversas do dia tiveram 0 segundos de espera (ex: por atendimento automático ou resposta instantânea).',
	['2.根据公式 「每日总等待时间 ÷ 每日对话数量」，计算结果经四舍五入后为 0 秒。']: '2. Pela fórmula "tempo total de espera diário ÷ número de conversas diárias", o resultado arredondado é 0 segundos.',
	['系统显示为 「未登入」 时，表示该帐号在其设定的团队时间内未产生任何对话数据。']: 'Quando o sistema mostra "Não conectado", indica que a conta não gerou dados de conversa durante o período da equipe.',
	['加入微调']: 'Adicionar ao ajuste fino',
	['启用API Key']: 'Ativar chave API',
	['微调汇入对话记录']: 'Importar histórico de conversas para ajuste fino',
	['对话数量']: 'Número de conversas',
	['文本最后角色需为AI或客服人员']: 'O último perfil do texto deve ser IA ou atendente',
	['汇入微调文本']: 'Importar texto de ajuste fino',
	['檔案格式：CSV，且档案大小不得大于']: 'Formato: CSV, e o tamanho do arquivo não pode exceder',
	['文本最后角色需为AI或客服人员，请修改后再进行汇出或执行微调']: 'O último perfil do texto deve ser IA ou atendente, edite antes de exportar ou executar ajuste fino',
	['批量加入微调']: 'Adicionar ajuste fino em lote',
	['自定加入微调的名称']: 'Nome personalizado do ajuste fino',
	['微调名称']: 'Nome do ajuste fino',
	['请输入微调的名称']: 'Insira o nome do ajuste fino',
	['微调的名称']: 'Nome do ajuste fino',
	['请确认是否批量删除(共 {{selectedFineTuningRecordsLength}} 笔']: 'Confirma excluir em lote (total {{-selectedFineTuningRecordsLength}} registros)',
	['已取消']: 'Cancelado',
	['取消微调']: 'Cancelar ajuste fino',
	['取消微调成功']: 'Ajuste fino cancelado com sucesso',
	['取消此笔客服系统微调训练时，需要同时取消对应的 OpenAI 后台微调训练。只有两者均取消后，微调训练才会被完整移除。请确认是否要取消此客服系统微调训练？']: 'Ao cancelar este ajuste fino do sistema, também deve cancelar o ajuste fino correspondente no backend do OpenAI. Apenas após ambos cancelados, o ajuste fino será completamente removido. Confirma cancelar?',
	['复制快捷语成功']: 'Resposta rápida copiada com sucesso',
	['复制常用图片成功']: 'Imagem frequente copiada com sucesso',
	['左侧']: 'Esquerda',
	['右侧']: 'Direita',
	['{{text}}正在服务{{total}}则对话']: '{{-text}} está atendendo {{-total}} conversas',
	['新增跑马灯成功']: 'Letreiro adicionado com sucesso',
	['修改跑马灯成功']: 'Letreiro editado com sucesso',
	['刪除跑马灯成功']: 'Letreiro excluído com sucesso',
	['启用跑马灯成功']: 'Letreiro ativado com sucesso',
	['停用跑马灯成功']: 'Letreiro desativado com sucesso',
	['对象栏位']: 'Campo do objeto',
	['显示跑马灯内容']: 'Exibir conteúdo do letreiro',
	['请确认是否启用跑马灯？']: 'Confirma ativar o letreiro?',
	['请确认是否停用跑马灯？']: 'Confirma desativar o letreiro?',
	['请确认是否删除跑马灯？']: 'Confirma excluir o letreiro?',
	['{{text}}最多{{inputLimit}}组']: '{{text}} máximo {{inputLimit}} grupos',
	['数值范围']: 'Faixa de valores',
	['数值不能为空']: 'O valor não pode estar vazio',
	['数值']: 'Valor',
	['请输入数字']: 'Insira um número',
	['输入多组文字请用, 区隔']: 'Para vários textos, separe com vírgula',
	['当用户符合对象设定名称及栏位规则中的内容时，才会生效跑马灯推广']: 'O letreiro só é ativado quando o usuário corresponde ao nome do objeto e às regras de campo',
	['新增跑马灯']: 'Adicionar letreiro',
	['对象栏位不能为空']: 'O campo do objeto não pode estar vazio',
	['请输入对象栏位']: 'Insira o campo do objeto',
	['栏位规则']: 'Regras de campo',
	['栏位规则不能为空']: 'As regras de campo não podem estar vazias',
	['请选择栏位规则']: 'Selecione as regras de campo',
	['开头图示']: 'Ícone inicial',
	['开头图示不能为空']: 'O ícone inicial não pode estar vazio',
	['请选择开头图示']: 'Selecione o ícone inicial',
	['跑马灯内容']: 'Conteúdo do letreiro',
	['修改跑马灯']: 'Editar letreiro',
	['变更的平台设定将同步套用至下级角色，是否确认修改？']: 'As alterações nas configurações da plataforma serão aplicadas aos perfis subordinados, confirma editar?',
	['确认要删除[个人/公共]常用图片[{{title}}]吗？']: 'Confirma excluir imagem frequente [{{title}}] [pessoal/pública]?',
	['一经确认删除无法复原。']: 'Após confirmar a exclusão, não pode ser desfeita.',
	['客服日志']: 'Log do atendente',
	['请输入内容等关键字']: 'Insira conteúdo ou outras palavras-chave',
	['确认要删除[个人/公共]快捷语[{{title}}]：[{{content}}]吗？']: 'Confirma excluir resposta rápida [{{title}}]: [{{content}}] [pessoal/público]?',
	['没有其他进入标签被开启，故无法关闭此进入标签']: 'Nenhuma outra etiqueta de entrada está ativa, não é possível desativar esta',
	['没有其他进入标签被开启，故无法删除此标签']: 'Nenhuma outra etiqueta de entrada está ativa, não é possível excluir esta',
	['所有人']: 'Todos',
	['自定义对象']: 'Objeto personalizado',
	['套用对象']: 'Aplicar objeto',
	['回主画面']: 'Voltar à tela inicial',
	['孟加拉语']: 'বাংলা',
	['繁体中文']: '繁體中文',
	['简体中文']: '简体中文',
	['韩语']: '한국어',
	['日语']: '日本語',
	['葡萄牙语']: 'Português',
	['印地语']: 'हिंदी',
	['俄语']: 'русский язык',
	['重要资讯']: 'Informações importantes',
	['在对话中切换语言，在某些情况下，可能导致讯息翻译功能延迟约 10 分钟，影响新旧讯息的读取。确定要切换语言?']: 'Alterar o idioma durante uma conversa pode causar atraso de aprox. 10 minutos na tradução de mensagens em alguns casos, afetando leitura de mensagens novas e antigas. Confirma alterar?',
	['暂无对话']: 'Nenhuma conversa',
	['档案上传中']: 'Enviando arquivo...',
	['{{name}} 已于 {{time}} 开启自动推播']: '{{-name}} ativou a notificação automática às {{-time}}',
	['{{name}} 已于 {{time}} 关闭自动推播']: '{{-name}} desativou a notificação automática às {{-time}}',
	['商户代码']: 'Código do Comerciante',
	['请输入商户代码']: 'Por favor, insira o código do comerciante',
	['密钥']: 'Chave Secreta',
	['请输入密钥']: 'Por favor, insira a chave secreta',
	['共同设定']: 'Configuração Comum',
	['充值未到帐设定']: 'Configuração de Recarga Não Creditada',
	['出款未到帐设定']: 'Configuração de Saque Não Creditado',
	['确认进行储存？']: 'Confirmar salvar?',
	['SKILL开关']: 'Interruptor SKILL',
	['请输入SKILL']: 'Inserir SKILL',
	['派单 API 参数']: 'Parâmetros da API de ticket',
	['请输入派单API URL']: 'Inserir URL da API de ticket',
	['开单者username']: 'Nome de usuário do criador do ticket',
	['请输入开单者username']: 'Inserir nome de usuário do criador do ticket',
	['频道名称']: 'Nome do canal',
	['请输入频道名称']: 'Inserir nome do canal',
	['开单原因']: 'Motivo do ticket',
	['请输入开单原因']: 'Inserir motivo do ticket',
	['充值订单查询 API URL']: 'URL da API de consulta de pedido de recarga',
	['出款订单查询 API URL']: 'URL da API de consulta de pedido de saque',
	['同义词设定']: 'Configurações de sinônimos',
	['开启BM25']: 'Ativar BM25',
	['同义词']: 'Sinônimo',
	['更新时间']: 'Hora de atualização',
	['批次新增同义词']: 'Adicionar sinônimos em lote',
	['修改同义词']: 'Editar sinônimos',
	['新增同义词']: 'Adicionar sinônimo',
	['请输入同义词，使用逗号区隔不同词汇']: 'Insira sinônimos, separe palavras diferentes com vírgulas',
	['请以逗号区隔不同词汇，用分号区隔不同组同义词']: 'Use vírgulas para separar palavras diferentes e ponto e vírgula para separar grupos de sinônimos',
	['输入格式说明：']: 'Instruções de formato:',
	['请用，区隔不同词汇，例如：充值,储值,入金,课金']: 'Use vírgula para separar palavras diferentes, ex.: recarga, depósito, ingresso, pagamento',
	['词汇与标点符号前后不要出现空白']: 'Não deixe espaços antes e depois das palavras e pontuação',
	['请用；或分行(enter)区隔同组同义词，例如：']: 'Use ; ou quebra de linha (enter) para separar grupos de sinônimos, ex.:',
	['充值,储值,入金,课金']: 'recarga, depósito, ingresso, pagamento',
	['log in,登入;亲,宝贝']: 'log in, entrar; querido(a), amor',
	['请输入同义词']: 'Insira sinônimos',
	['同义词不可为空']: 'Os sinônimos não podem estar vazios',
	['同义词格式有误']: 'Formato de sinônimos inválido',
	['同义词不可有特殊字元']: 'Sinônimos não podem ter caracteres especiais',
	['字元不可超过10000']: 'Não pode exceder 10000 caracteres',
	['需至少输入两个词汇']: 'Deve inserir pelo menos duas palavras',
	['删除同义词']: 'Excluir sinônimos',
	['请确认是否删除同义词？']: 'Confirma excluir sinônimos?',
	['新增同义词成功']: 'Sinônimos adicionados com sucesso',
	['新增同义词失败']: 'Falha ao adicionar sinônimos',
	['修改同义词成功']: 'Sinônimos editados com sucesso',
	['修改同义词失败']: 'Falha ao editar sinônimos',
	['删除同义词成功']: 'Sinônimos excluídos com sucesso',
	['删除同义词失败']: 'Falha ao excluir sinônimos',
	['内容有重复字']: 'Conteúdo com caracteres duplicados',
	['新增图片，详细图片请参考公告管理']: 'Adicionar imagem, para detalhes consulte a gestão de anúncios',
	['目前只支援ChatGPT进行微调训练']: 'Atualmente apenas ChatGPT é suportado para ajuste fino',
	['AI系列']: 'Série de IA',
	['AI系列不能为空']: 'A série de IA não pode estar vazia',
	['启用ChatGPT']: 'Ativar ChatGPT',
	['启用Gemini']: 'Ativar Gemini',
	['AI客服']: 'Atendimento IA',
	['ID入口']: 'Entrada por ID',
	['IP']: 'IP',
	['USER ID']: 'ID de usuário',
	['{{itemLabel}}內容不可为空']: 'O conteúdo de {{itemLabel}} não pode estar vazio',
	['{{text}}仅能输入数字']: '{{text}} aceita apenas números',
	['{{text}}最多{{limit}}个字元']: '{{text}} máximo {{limit}} caracteres',
	['{{text}}最多數字{{limit}}碼']: '{{text}} máximo {{limit}} dígitos',
	['{{time}}分']: '{{time}} minutos',
	['{{time}}时']: '{{time}} horas',
	['{{time}}秒']: '{{time}} segundos',
	['上一则发送后等待时间']: 'Tempo de espera após a mensagem anterior',
	['上传图片']: 'Enviar imagem',
	['主要API keys']: 'Chaves API principais',
	['主要语言']: 'Idioma principal',
	['事件']: 'Evento',
	['以查看预览效果']: 'para ver a visualização',
	['依照选择模组设定UI显示位置及功能。']: 'Configurar posição e função de exibição da UI conforme o módulo selecionado.',
	['依照选择的风格进行调整配色（含背景、框体、配色、线条感）。']: 'Ajustar cores conforme o estilo selecionado (incluindo fundo, contêiner, cores, linhas).',
	['修改帐号履历成功']: 'Histórico da conta editado com sucesso',
	['修改翻译API成功']: 'API de tradução editada com sucesso',
	['充值帐号']: 'Conta de recarga',
	['共 {{numOfItems}} 笔']: 'Total {{numOfItems}} registros',
	['关 闭']: 'Fechar',
	['关闭后，整个推播系统将停止运作，所有推播讯息会暂时无效。您随时可以重新开启。']: 'Após desativar, todo o sistema de notificações parará e todas as mensagens ficarão temporariamente inválidas. Você pode reativar a qualquer momento.',
	['内容最多20字元']: 'Conteúdo máximo 20 caracteres',
	['内容预览']: 'Visualização do conteúdo',
	['切换后，跑马灯文字与快捷键可能会出现显示不清晰或对比度不足的情况，需到后台进行重新设定']: 'Após alternar, texto do letreiro e atalhos podem ter visualização pouco clara ou contraste insuficiente, sendo necessário reconfigurar no painel',
	['删除履历']: 'Excluir histórico',
	['删除帐号履历成功']: 'Histórico da conta excluído com sucesso',
	['删除跑马灯']: 'Excluir letreiro',
	['加载中...']: 'Carregando...',
	['勾选后，该账号在联系客服时，账号名称旁会显示']: 'Quando marcado, ao contatar o atendimento o nome da conta será exibido ao lado',
	['即时预览']: 'Visualização em tempo real',
	['取消新增微调文本']: 'Cancelar adição de texto de ajuste fino',
	['古典深色风格']: 'Estilo escuro clássico',
	['單次']: 'Uma vez',
	['回传表单']: 'Formulário de resposta',
	['外观风格']: 'Estilo visual',
	['客户端视觉设定']: 'Configurações visuais do cliente',
	['客户端视觉设定成功']: 'Configurações visuais do cliente salvas com sucesso',
	['尚无资料']: 'Sem dados',
	['展开']: 'Expandir',
	['履历数量']: 'Quantidade de históricos',
	['帐号履历']: 'Histórico da conta',
	['帐号履历管理']: 'Gestão do histórico da conta',
	['平台代码不能有空白']: 'O código da plataforma não pode ter espaços',
	['平台代码仅能输入英文和数字']: 'O código da plataforma aceita apenas letras e números',
	['平台代码最多5码']: 'Código da plataforma máximo 5 caracteres',
	['平台代码最少2码']: 'Código da plataforma mínimo 2 caracteres',
	['平台语言']: 'Idioma da plataforma',
	['平均首次工作时间']: 'Tempo médio do primeiro trabalho',
	['建立者']: 'Criador',
	['开关']: 'Interruptor',
	['快速通道']: 'Canal rápido',
	['手动推播']: 'Notificação manual',
	['手机版']: 'Versão móvel',
	['批量删除']: 'Excluir em lote',
	['排序']: 'Ordenação',
	['推播功能']: 'Função de notificação',
	['推播功能 OFF：推播功能关闭整个系统不运作，列表中的所有策略都无效。']: 'Notificação OFF: a função desativada interrompe todo o sistema, todas as estratégias da lista ficam inválidas.',
	['推播时间']: 'Hora da notificação',
	['推播讯息列表']: 'Lista de mensagens de notificação',
	['推播设定']: 'Configurações de notificação',
	['操作内容']: 'Conteúdo da operação',
	['收起']: 'Recolher',
	['数值/内容']: 'Valor/Conteúdo',
	['数值/内容不可为空']: 'Valor/Conteúdo não pode estar vazio',
	['数值只能输入数字、负号、小数点']: 'Valor só aceita números, sinal negativo e ponto decimal',
	['数值小数最多6位数']: 'Valor decimal máximo 6 dígitos',
	['数值整数最多15位']: 'Valor inteiro máximo 15 dígitos',
	['新增履历']: 'Adicionar histórico',
	['新增帐号履历成功']: 'Histórico da conta adicionado com sucesso',
	['新增类型']: 'Adicionar tipo',
	['无工作']: 'Sem trabalho',
	['时间设定需至少为 3 分钟']: 'O tempo configurado deve ser de pelo menos 3 minutos',
	['是否修改翻译API?']: 'Editar API de tradução?',
	['更新成功']: 'Atualizado com sucesso',
	['更新者']: 'Editor',
	['架构模组']: 'Módulo de arquitetura',
	['栏位名称']: 'Nome do campo',
	['栏位类型']: 'Tipo de campo',
	['栏位类型不可为空']: 'O tipo de campo não pode estar vazio',
	['档案格式不符']: 'Formato de arquivo inválido',
	['PDF文件']: 'Documento PDF',
	['模式与间隔时间']: 'Modo e intervalo de tempo',
	['欢迎回来']: 'Bem-vindo(a) de volta',
	['此操作将自动翻译其他语言，原有输入内容将被翻译结果覆盖，请确认是否继续？']: 'Esta operação traduzirá automaticamente para outros idiomas, e o conteúdo original será sobrescrito. Confirma continuar?',
	['汇入']: 'Importar',
	['汇入微调文本成功']: 'Texto de ajuste fino importado com sucesso',
	['汇出微调文本成功']: 'Texto de ajuste fino exportado com sucesso',
	['清空翻译']: 'Limpar tradução',
	['所有语系内容皆填写完成后才可确定，可使用自动翻译补齐其余语系']: 'Todos os idiomas devem ser preenchidos antes de confirmar. Você pode usar a tradução automática para preencher os idiomas restantes.',
	['标题与内容皆需填写才可自动翻译']: 'O título e o conteúdo devem ser preenchidos antes da tradução automática.',
	['状态持续时间']: 'Duração do status',
	['用户帐号']: 'Conta do usuário',
	['用户帐号不能为空']: 'A conta do usuário não pode estar vazia',
	['电脑版']: 'Versão desktop',
	['目前无适用推播']: 'Nenhuma notificação aplicável no momento',
	['目前有启用中的侦测语言平台，无法关闭']: 'Há plataformas de detecção de idioma ativas, não é possível desativar',
	['确定删除IP白名单？']: 'Confirma excluir da lista branca de IP?',
	['确定发送推播？']: 'Confirma enviar notificação?',
	['确定要关闭推播功能吗？']: 'Confirma desativar a função de notificação?',
	['确认删除此笔履历?']: 'Confirma excluir este histórico?',
	['确认要删除推播讯息？']: 'Confirma excluir mensagem de notificação?',
	['立即登入']: 'Entrar agora',
	['第 {{min}} - {{max}} 笔/共 {{numOfItems}} 笔']: '{{min}} - {{max}} de {{numOfItems}}',
	['筛选条件']: 'Filtros',
	['类型名称']: 'Nome do tipo',
	['系统预设模组']: 'Módulo padrão do sistema',
	['经典浅色风格']: 'Estilo claro clássico',
	['翻译API']: 'API de tradução',
	['聊天介面']: 'Interface de chat',
	['自动推播']: 'Notificação automática',
	['自动推播功能']: 'Função de notificação automática',
	['自动推播功能 OFF：列表中的所有推播讯息虽然仍可被客服手动执行，但所有计时器功能停止运作。']: 'Notificação automática OFF: as mensagens da lista ainda podem ser enviadas manualmente, mas todos os temporizadores param.',
	['自定义']: 'Personalizado',
	['自定义文案']: 'Texto personalizado',
	['自客服接起对话后开始计算']: 'Contagem a partir do início do atendimento',
	['该类型目前有推播讯息套用中，无法删除']: 'Este tipo tem notificações aplicadas, não pode excluir',
	['详细说明']: 'Detalhes',
	['请先选择推播类型']: 'Selecione o tipo de notificação primeiro',
	['请确认是否批量删除(共 {{selectedFineTuningRecordsLength}} 笔)？']: 'Confirma excluir em lote (total {{selectedFineTuningRecordsLength}} registros)?',
	['请输入事件']: 'Insira o evento',
	['请输入会员ID']: 'Por favor, insira o ID de membro',
	['请输入內容']: 'Insira o conteúdo',
	['请输入关键字']: 'Insira a palavra-chave',
	['请输入您的会员 ID 以继续']: 'Por favor, insira seu ID de membro para continuar',
	['请输入数值/内容']: 'Insira valor/conteúdo',
	['请输入文字']: 'Insira texto',
	['请输入栏位名称']: 'Insira o nome do campo',
	['请输入用户帐号']: 'Insira a conta do usuário',
	['请输入类型名称']: 'Insira o nome do tipo',
	['请输入详细说明']: 'Insira a descrição detalhada',
	['请选择上方下拉选单']: 'Selecione no menu acima',
	['请选择主要语言自动翻译']: 'Selecione o idioma principal para tradução automática',
	['请选择帐号状态']: 'Selecione o status da conta',
	['请选择平台']: 'Selecione a plataforma',
	['请选择推播项目']: 'Selecione o item de notificação',
	['请选择栏位类型']: 'Selecione o tipo de campo',
	['请选择类型']: 'Selecione o tipo',
	['请选择类型与项目(标题)以预览内容']: 'Selecione tipo e item (título) para visualizar o conteúdo',
	['请选择表单选项']: 'Selecione a opção do formulário',
	['请选择运算规则']: 'Selecione a regra de operação',
	['请选择预览画面']: 'Selecione a tela de visualização',
	['跑马灯设定']: 'Configurações do letreiro',
	['轮播']: 'Carrossel',
	['轮播模式']: 'Modo carrossel',
	['轮播间隔时间']: 'Intervalo do carrossel',
	['运算规则']: 'Regras de operação',
	['运算规则不可为空']: 'As regras de operação não podem estar vazias',
	['返回上一层']: 'Voltar ao nível anterior',
	['返回上一页']: 'Voltar à página anterior',
	['送出推播']: 'Enviar notificação',
	['选单介面']: 'Interface do menu',
	['选择推播类型']: 'Selecionar tipo de notificação',
	['选择推播项目(标题)']: 'Selecionar item de notificação (título)',
	['通知时间']: 'Hora da notificação',
	['通知时间不能为空']: 'A hora da notificação não pode estar vazia',
	['重新产生Key/IV']: 'Regenerar Key/IV',
	['重要客户']: 'Cliente importante',
	['需为1~60正整数']: 'Deve ser um inteiro positivo entre 1 e 60',
	['预估时间']: 'Tempo estimado',
	['预览图片']: 'Visualizar imagem',
	['首次工作时间报表']: 'Relatório do primeiro tempo de trabalho',
	['日志管理']: 'Gestão de logs',
	['API传送日志']: 'Log de transmissão API',
	['订单号']: 'Número do pedido',
	['三方单号']: 'Número do pedido de terceiros',
	['请输入订单号']: 'Por favor, insira o número do pedido',
	['请输入三方单号']: 'Por favor, insira o número do pedido de terceiros',
	['充值订单查询']: 'Consulta de pedidos de recarga',
	['出款订单查询']: 'Consulta de pedidos de retirada',
	['开派单']: 'Criar ticket',
	['传送派单信息']: 'Enviar informações do ticket',
	['CS传送资料']: 'Dados enviados pelo CS',
	['平台回覆资料']: 'Dados de resposta da plataforma',
	['{{text}}需以{{prefix}}开头']: '{{-text}} deve começar com {{-prefix}}',
	['系统通知']: 'Notificação do sistema',
	['派单传送讯息']: 'Enviar mensagem de despacho',
	['派单传送档案']: 'Enviar arquivo de despacho',
	['请输入平台']: 'Por favor, insira a plataforma',
	['派单讯息润饰设定']: 'Configurações de refinamento da mensagem de despacho',
	['此指令不会载入「AI共同设定」与「平台AI设定」，为独立的 Agent 使用']: 'Esta instrução não carrega "Configurações comuns da IA" nem "Configurações IA da plataforma"; é usada como um Agent independente',
	['用户个人设定']: 'Configurações pessoais do usuário',
	['新增用户个人资讯']: 'Adicionar informações pessoais do usuário',
	['个人资讯参数名称']: 'Nome do parâmetro de informações pessoais',
	['请输入个人资讯参数名称']: 'Insira o nome do parâmetro de informações pessoais',
	['*新增多个请使用逗号「 , 」隔开']: '*Para adicionar vários, separe-os com vírgulas「 , 」',
	['用来设定该平台哪些个人资讯要丢给AI，只有设定在「用户个人设定」的参数，才会传送给AI']: 'Usado para definir quais informações pessoais desta plataforma são enviadas à IA. Apenas os parâmetros definidos em "Configurações pessoais do usuário" serão enviados à IA',
	['批次删除用户个人资讯']: 'Excluir em lote informações pessoais do usuário',
	['确定要批次删除用户个人资讯吗？']: 'Tem certeza de que deseja excluir em lote as informações pessoais do usuário?',
	['个人资讯参数名称不能为空']: 'O nome do parâmetro de informações pessoais não pode estar vazio',
	['已存在「{{name}}」']: '"{{-name}}" já existe',
	['最多可新增{{limit}}个，已超过上限']: 'É possível adicionar no máximo {{-limit}}; o limite foi excedido',
	['新增用户个人资讯成功']: 'Informações pessoais do usuário adicionadas com sucesso',
	['新增用户个人资讯失败']: 'Falha ao adicionar informações pessoais do usuário',
	['删除用户个人资讯成功']: 'Informações pessoais do usuário excluídas com sucesso',
	['删除用户个人资讯失败']: 'Falha ao excluir informações pessoais do usuário',
	['图像管理']: 'Gerenciamento de imagens',
	['自定义图像']: 'Imagem personalizada',
	['档案格式：“PNG、JPG”档案大小不得大于 500KB']: 'Formato de arquivo: "PNG, JPG", o tamanho do arquivo não pode exceder 500KB',
	['档案最大500K']: 'Arquivo máximo de 500K',
	['新增图像成功']: 'Imagem adicionada com sucesso',
	['删除图像成功']: 'Imagem excluída com sucesso',
	['是否确定删除图像？']: 'Tem certeza de que deseja excluir esta imagem?',
	['内容设定']: 'Configurações de conteúdo',
	['英语']: 'Inglês',
	['{{language}}内容']: 'Conteúdo em {{language}}',
	['请输入{{language}}内容']: 'Insira o conteúdo em {{language}}',
	['请选择时间']: 'Selecione o horário',
	['请选择公司']: 'Selecione a empresa',
	['请输入{{label}}']: 'Insira {{label}}',
	['原文参考（{{language}}）']: 'Referência do texto original ({{language}})',
	['确定清空设定吗？']: 'Tem certeza de que deseja limpar as configurações?',
	['确定取消设定吗？']: 'Tem certeza de que deseja cancelar as configurações?',
	['{{language}}{{tab}}']: '{{language}} {{tab}}',
	['未完成']: 'Incompleto',
	['{{language}}{{label}}超过{{limit}}字']: 'O {{label}} de {{language}} excede {{limit}} caracteres',
	['公告标题']: 'Título do anúncio',
	['进线IP']: 'IP de entrada',
	['请输入进线IP']: 'Insira o IP de entrada',
	['模型切换：{{fromModel}} -> {{toModel}}']: 'Modelo alterado: {{fromModel}} -> {{toModel}}',
	['包网后台删除帐号后，客服系统帐号将同步删除']: 'Após excluir a conta no backend do BW, a conta do sistema de atendimento será excluída de forma sincronizada',
	['系统已有新版本，请重新整理']: 'Uma nova versão está disponível, atualize a página',
	['页面加载失败，请重试']: 'Falha ao carregar a página, tente novamente',
	['翻译中']: 'Traduzindo',
	['监控与即时摘要设定']: 'Configurações de Monitoramento e Resumo Instantâneo',
	['批量转接']: 'Transferência em massa',
	['已选 {{count}} 则对话']: '{{count}} conversas selecionadas',
	['勾选']: 'Selecionar',
	['全平台服务人数']: 'Número de atendimentos em todas as plataformas',
	['未开启{{platform}}平台']: 'A plataforma {{-platform}} não está ativada',
	['成功由 {{inviter}} 转接至 {{invitee}}，共 {{count}} 则']: 'Transferência de {{-inviter}} para {{-invitee}} concluída, {{count}} no total.',
	['接受']: 'Aceitar',
	['拒绝({{seconds}}S)']: 'Recusar({{seconds}}S)',
	['生成链接']: 'Gerar link',
	['链接生成中...']: 'Gerando link...',
	['复制链接']: 'Copiar link',
	['已复制链接']: 'Link copiado',
	['档案上传失败']: 'Falha no envio do arquivo',
	['转档失败，请重新上传']: 'Falha na conversão, faça o upload novamente',
	['人工回复']: 'Resposta manual',
	['检视回复']: 'Ver resposta',
	['{{time}} AI 拦截对话']: '{{time}} IA interceptou a conversa',
	['AI 拦截原因与人工回复']: 'Motivo da interceptação da IA e resposta manual',
	['人工回复失败']: 'Falha na resposta manual',
	['回复讯息']: 'Mensagem de resposta',
	['对话摘要']: 'Resumo da conversa',
	['建议回复']: 'Resposta sugerida',
	['拦截原因']: 'Motivo da interceptação',
	['拦截回复']: 'Resposta interceptada',
	['确定送出']: 'Confirmar e enviar',
	['生成链接失败']: 'Falha ao gerar o link',
	['连接超时，请稍后再试']: 'A conexão expirou, tente novamente mais tarde',
	['上一则']: 'Anterior',
	['下一则']: 'Próximo',
	['重新传送']: 'Reenviar',
	['传送中...']: 'Enviando...',
	['用户端翻译失败']: 'Falha na tradução para o cliente',
	['重新传送失败']: 'Falha no reenvio',
	['请确认是否删除以下模型？']: 'Confirma a exclusão do seguinte modelo?',
	['新增模型']: 'Adicionar modelo',
	['请选择AI系列']: 'Selecione a série de IA',
	['支援模型']: 'Modelo suportado',
	['支援模型不能为空']: 'O modelo suportado não pode ficar vazio',
	['请选择支援模型']: 'Selecione o modelo suportado',
	['AI模型管理']: 'Gestão de modelos de IA',
	['模型不能为空']: 'O modelo não pode ficar vazio',
	['请选择模型']: 'Selecione um modelo',

	['对话类型']: 'Tipo de conversa',
	['单纯AI讯息']: 'Apenas mensagens da IA',
	['单纯人员讯息']: 'Apenas mensagens do atendente',
	['人员+AI讯息']: 'Mensagens do atendente + IA',
	['是否经过AI拦截']: 'Foi interceptado pela IA?',
	['是否修改AI拦截建议回覆']: 'A resposta sugerida pela IA foi modificada?',
	['监控API keys']: 'Chaves API de monitorização',
	['管理']: 'Gerenciar',

	['启用显性快取']: 'Ativar cache explícito',
	['AI监控拦截总量']: 'Total de interceções da IA',
	['AI监控拦截']: 'Interceções da IA',
	['有修改建议回覆总量']: 'com resposta sugerida modificada',
	['触发关键字：{{keywords}}。']: 'Palavras-chave acionadas: {{-keywords}}.',

	['版面已套用，但尚未同步至帐号']: 'Layout aplicado, mas ainda não sincronizado com a conta',
	['服务器重设失败，下次开启工作区时会再同步']: 'Falha ao redefinir no servidor; será sincronizado novamente na próxima vez que abrir a área de trabalho',
	['浏览器无法储存版面，离开前请确认帐号同步完成']: 'O navegador não consegue salvar o layout; confirme a sincronização com a conta antes de sair',

	['重设版面配置']: 'Redefinir layout',
	['确定要将版面配置回复为系统预设吗？']: 'Deseja restaurar o layout para o padrão do sistema?',
	['客服支援语言']: 'Idiomas suportados pelo atendimento',
	['请选择支援语言']: 'Selecione os idiomas suportados',
	['请选择客服支援语言']: 'Selecione os idiomas suportados pelo atendimento',

	['删除平台']: 'Excluir plataforma',
	['是否确定删除{{code}}平台']: 'Tem certeza de que deseja excluir a plataforma {{-code}}?',
	['删除{{code}}平台成功']: 'Plataforma {{-code}} excluída com sucesso.',
	['上传图片或PDF']: 'Enviar imagem ou PDF',
	['当前平台维护中，如有疑问请联系管理员']: 'A plataforma atual está em manutenção. Em caso de dúvidas, contate o administrador.',
	['当前平台已禁用，如有疑问请联系管理员']: 'A plataforma atual foi desativada. Em caso de dúvidas, contate o administrador.',
	['收回提示文字']: 'Texto de aviso de retirada',
	['请输入提示文字，例如：抱歉亲 妹子发错了更正一下哦！']: 'Insira o texto, por exemplo: Desculpe! Enviei errado, vou corrigir agora!',
	['标签名称']: 'Nome da etiqueta',
	['预览失败']: 'Falha na pré-visualização',
	['放大']: 'Ampliar',
	['缩小']: 'Reduzir',
	['上一页']: 'Página anterior',
	['下一页']: 'Próxima página',
	['点击预览']: 'Clique para visualizar',
};
